angular.module('controllers').controller('slotController', ['$scope', '$rootScope', '$controller', '$route', '$routeParams', '$location', '$timeout', '$interval', 'Crud', '$filter', 'orderByFilter', '$window', '$mdDialog', '$compile', 'Mqtt',
    function ($scope, $rootScope, $controller, $route, $routeParams, $location, $timeout, $interval, Crud, $filter, orderByFilter, $window, $mdDialog, $compile, Mqtt) {

        Mqtt.connect($rootScope.mq);

        $rootScope.path = '/slot';
        $scope.path = $rootScope.path;
        $rootScope.modelName = 'slot';
        $scope.pathTemplate = 'distribution/slots';
        $scope.title = 'Dispecerat';

        angular.extend(this, $controller('crudController', {$scope: $scope}));

        $scope.sortType = 'slot_no';
        $scope.defaultItem = 10;
        $rootScope.typeId = 'id';
        $scope.search.order = 'desc';
        $scope.classAction = 'td-big';
        $scope.additionals['publicAudioPath'] = '/audio';
        $scope.additionals['pathOrder'] = '/order';
        $scope.additionals['publicAppPath'] = '/images/app';

        $scope.additionals['dispatchTimeOrder'] = 0;
        $scope.additionals['kitchenTimeOrder'] = 0;
        $scope.additionals['plannedTimeOrder'] = 0;
        $scope.additionals['distributionTimeOrder'] = 0;
        $scope.additionals['deliveryTimeOrder'] = 0;
        $scope.additionals['dispatchTimeOrderActive'] = 0;
        $scope.additionals['kitchenTimeOrderActive'] = 0;
        $scope.additionals['plannedTimeOrderActive'] = 0;
        $scope.additionals['distributionTimeOrderActive'] = 0;
        $scope.additionals['deliveryTimeOrderActive'] = 0;

        $scope.additionals['searchTerm'];
        $scope.additionals['clearSearchTerm'] = function() {
          $scope.additionals['searchTerm'] = '';
        };
        $scope.additionals['onSearchChange'] = function(ev) {
          ev.stopPropagation();
        };

        $scope.additionals.showColumns = {'code':'code', 'name':'name', 'price':'price', 'total_price':'total_price'};

        $scope.columns = {
            //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
            'slot_no': {'label': 'Nr. slot', 'filter': 1, 'filterType': 'input'},
            'orders': {'label': 'Comenzi', 'filter': 2, 'filterType': 'input'},
            //'orders':{'label':'Comenzi', 'filter':1, 'filterType':'input'},
            'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
            'created_at': {'label': 'Data', 'filter': 1, 'filterType': 'input'},

            'total_cash': {'label': 'Cash de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            'total_card': {'label': 'Card de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            'total_online': {'label': 'Online (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            'total_bonsv': {'label': 'Bonuri de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            'total_bank_transfer': {'label': 'Transfer bancar (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

            //'total_order_discount':{'label':'Discount ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
            'total_driver': {'label': 'Total cash sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            'amount_driver_cash_required': {'label': 'Total de incasat cash sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            'amount_dispatcher_cash_collected': {'label': 'Suma incasata cash dispecer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            //'amount_dispatcher_card_collected':{'label':'Suma incasata card dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
            'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            'slot_status': {'label': 'Slot status', 'filter': 1, 'filterType': 'select'},
            'status': {'label': 'Status', 'filter': 1, 'filterType': 'select'}
        };
        $scope.columns.status.options = [
            {'id': '', 'value': ''},
            {'id': 1, 'value': 'true'},
            {'id': 0, 'value': 'false'}
        ];
        $scope.columns.slot_status.options = [
            {'id': '', 'value': ''},
            {'id': 1, 'value': 'inchis'},
            {'id': 0, 'value': 'deschis'}
        ];

        $scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'slot_no';

        $scope.additionals['type_orders'] = [
            {'value': 'order_active', 'name': 'Comenzi active'},
            {'value': 'order_cancelled', 'name': 'Comenzi anulate'}
        ];

        $scope.additionals['discount_types'] = [
            {'id': 0, 'value': 'procent', 'mark': '%'},
            {'id': 1, 'value': 'suma fixa', 'mark': ''}
        ];
        $scope.additionals['discount_campaign_value_type'] = {};
        $scope.additionals['discount_campaign_value_type'].options = $scope.additionals['discount_types'];
        $scope.additionals['discount_campaign_types'] = [
            {'id': 0, 'value': 'Reducere one-time'},
            {'id': 1, 'value': 'Reducere multipla'}
        ];
        $scope.additionals['discount_campaign_type'] = {};
        $scope.additionals['discount_campaign_type'].options = $scope.additionals['discount_campaign_types'];

        $scope.additionals['incident_departments'] = [
            {'id': 1, 'value': 'Bucatarie'},
            {'id': 2, 'value': 'Livrare'},
            {'id': 3, 'value': 'Client'}
        ];
        $scope.additionals['incident_department'] = {};
        $scope.additionals['incident_department'].options = $scope.additionals['incident_departments'];

        /* filter search orders */
        $scope.filtersOrders = {};
        $scope.closeFilterSearchOrders = function () {
            $scope.filtersOrders = {};
            $scope.additionals['ordersAll'] = $scope.ordersAll;

            $scope.markers = {};
            angular.forEach($scope.additionals['ordersAll'], function (items, key) {
                $scope.createMarker(items);
            });
        }
        $scope.timesOrders = 0;
        $scope.filterSearchOrders = function () {

            $scope.timesOrders = $scope.timesOrders + 1;
            if ($scope.timesOrders == 1) {
                $scope.ordersAll = $scope.additionals['ordersAll'];
            }

            var results = $filter('filter')($scope.ordersAll, function (item) {
                var control = 0;
                if (!angular.isUndefined(item)) {
                    if (!angular.isUndefined(item.section_name) && item.section_name != null) {
                        if (item.section_name.toLowerCase().indexOf($scope.filtersOrders.searchOrders.toLowerCase()) > -1) {
                            control = 1;
                        }
                    }
                }
                if (control == 1) {
                    return true;
                }
            });

            if (results.length > 0) {
                $scope.additionals['ordersAll'] = results;
                $scope.markers = {};
                angular.forEach($scope.additionals['ordersAll'], function (items, key) {
                    $scope.createMarker(items);
                });

            } else {
                $scope.additionals['ordersAll'] = $scope.ordersAll;
                $scope.markers = {};
                angular.forEach($scope.additionals['ordersAll'], function (items, key) {
                    $scope.createMarker(items);
                });
            }

        }
        /* end filter search orders */

        /* custom filter */
        $scope.filtersOrder = {};
        $scope.closeFilterCustom = function () {
            $scope.filtersOrder = {};
            $scope.models = $scope.modelss;
        }
        $scope.times = 0;
        $scope.filterCustom = function () {
            $scope.times = $scope.times + 1;
            if ($scope.times == 1) {
                $scope.modelss = $scope.models;
            }
            var results = $filter('filter')($scope.modelss, function (item) {
                var control = 0;
                if (!angular.isUndefined(item.orders)) {
                    angular.forEach(item.orders, function (items, key) {
                        if (items.order_no == $scope.filtersOrder.fil) {
                            control = 1;
                        }
                        if (!angular.isUndefined(items.street_name) && items.street_name != null) {
                            if (items.street_name.toLowerCase().indexOf($scope.filtersOrder.fil.toLowerCase()) > -1 || items.address_no == $scope.filtersOrder.fil) {
                                control = 1;
                            }
                        }
                    });
                }
                if (control == 1) {
                    return true;
                }
            });

            if (results.length > 0) {
                $scope.models = results;
            } else {
                $scope.models = $scope.modelss;
            }
        }
        /* end custom filter */

        $scope.additionals['calcPlannedTime'] = function (date, minDiff) {
               duration = moment(date).format("x") - minDiff*60*1000;

                 /*  var date = new Date(date);
                 var duration = new Date( date.getTime() - minDiff *1000 * 60 );
                  console.log( duration)*/

            if(duration > 0){
                return moment(duration).format('HH:mm:ss');
            } else {
                return '00:00:00';
            }
        }

        $scope.additionals['calcProcess'] = function (data, add) {
           if (angular.isUndefined(add)){
             add = '';
           }
           if (!angular.isUndefined(data['order_start']) && !angular.isUndefined(data['validated_at'])) {
              $scope.additionals['dispatchTime'+add] = $scope.additionals['diffDatesMinutes'](data['order_start'], data['validated_at']);
            }
          if (!angular.isUndefined(data['order_planning']) && data['order_planning'] != null && data['order_planning'] != 'null' && data['order_planning'] != '' && !angular.isUndefined(data['validated_at']) && data['validated_at'] != null && data['validated_at'] != 'null') {
              $scope.additionals['kitchenTime'+add] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['order_planning'].substring(0, 10)+' '+$scope.additionals['calcPlannedTime'](data['order_planning'], data['planned_time']));

              if (!angular.isUndefined(data['processed_at'])) {
                $scope.additionals['plannedTime'+add] = $scope.additionals['diffDatesMinutes'](data['order_planning'].substring(0, 10)+' '+$scope.additionals['calcPlannedTime'](data['order_planning'], data['planned_time']), data['processed_at']);
              }
            } else {
              if (!angular.isUndefined(data['processed_at']) && !angular.isUndefined(data['validated_at'])) {
                  $scope.additionals['kitchenTime'+add] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['processed_at']);
                }
            }
            if (!angular.isUndefined(data['delivered_at']) && !angular.isUndefined(data['processed_at'])) {
              $scope.additionals['distributionTime'+add] = $scope.additionals['diffDatesMinutes'](data['processed_at'], data['delivered_at']);
            }
            if (!angular.isUndefined(data['order_end']) && !angular.isUndefined(data['delivered_at'])) {
              $scope.additionals['deliveryTime'+add] = $scope.additionals['diffDatesMinutes'](data['delivered_at'], data['order_end']);
            }

        }
        /* get last slot */
        $scope.getLastSlot = function () {
            Crud.get($scope.path + '/getLastSlot')
                    .success(function (data) {
                        $scope.additionals['lastSlot'] = data.lastSlot;
                        $rootScope.lastSlot = data.lastSlot;
                        $scope.notificationsAll = data.drivers;
                        $scope.additionals['max_amount_driver_required'] = data.max_amount_driver_required;
                    });
        }
        if ($location.path() == $scope.path) {
            $scope.getLastSlot();
        }

        /* get orders */
        $scope.getOrders = function (keySlot) {

            Crud.get($scope.path + '/getOrders')
                    .success(function (data) {
                        /*filter orders for updating real time*/
                        data.orders = data.orders.filter(function (item) {
                            var control = true;
                            angular.forEach($scope.additionals['slots'], function (items, key) {
                                angular.forEach(items['order_ids'], function (itemsId, keyId) {
                                    if (item.id.toString().indexOf(itemsId) > -1) {
                                        control = false;
                                    }
                                });
                            });
                            return control;
                        });
                        $scope.additionals['ordersAll'] = data.orders;
                        if (!angular.isUndefined(keySlot)) {
                            if (angular.isUndefined($scope.additionals['orders'])) {
                                $scope.additionals['orders'] = [];
                            }
                            $scope.additionals['orders'][keySlot] = data.orders;
                        }

                        /*display orders on the map*/
                        var arrayMarkers = angular.extend([], $scope.markers);
                        var newArrayMarkers = arrayMarkers.map(function (item) {
                            item['opacity'] = 0;
                            return item;
                        });
                        $scope.marker = angular.extend({}, newArrayMarkers);
                        angular.forEach(data.orders, function (item, key) {
                            $scope.createMarker(item);
                        });
                        $rootScope.slotNo = $rootScope.lastSlot;

                    });
        }
        if ($location.path() == $scope.path) {
            $scope.getOrders(0);
        }

        /* mqtt */

        /* update mqtt many orders */
        $scope.mqttUpdateManyOrdersDelivery = function (models) {
            if (!angular.isUndefined(models[0])) {
                if (models[0].current_status == -1) { //case for delete order
                    angular.forEach(models, function (items, keys) {
                        if (!angular.isUndefined($scope.modelsOrdersActive)) {
                            var positionOrdersActive = $scope.modelsOrdersActive.map(function (e) {
                                return e['id'];
                            }).indexOf(parseInt(items.order_id));
                            if (positionOrdersActive >= 0) {
                                $scope.modelsOrdersActive.splice(positionOrdersActive, 1);
                                if ($scope.modelsOrdersActive.length <= 0) {
                                    var no_pagesOrdersActive = Math.ceil(($scope.totalOrdersActive - 1) / perPageOrdersActive);
                                    if ($scope.modelsOrdersActive.current_page > no_pagesOrdersActive) {
                                        $scope.modelsOrdersActive.current_page = no_pagesOrdersActive;
                                    }
                                    if (angular.isUndefined($scope.modelsOrdersActive.current_page) || $scope.modelsOrdersActive.current_page == 0) {
                                        $scope.modelsOrdersActive.current_page = 1;
                                    }
                                    $scope.getOrders($scope.path, $scope.modelsOrdersActive.current_page, perPageOrdersActive);
                                }
                            }
                        }

                    });
                    $scope.getOrders();
                }
            }
        }

        /* mqtt update orders on delivery */
        $scope.mqttUpdateOrderDelivery = function (model, current_status, ex_status) {
            /*console.log(current_status)
             console.log(ex_status)*/
            if (current_status == 3) {
                if (!angular.isUndefined($scope.additionals['ordersAll'])) {
                    var position = $scope.additionals['ordersAll'].map(function (e) {
                        return e['id'];
                    }).indexOf(parseInt(model.id));
                    if (position < 0) {
                        if (model.shipping_method_id == "1" && ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && angular.isUndefined(model['order_planning']) || model['order_planning'] == null) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY'))   ) ) {

                            var pos = 0;
                            angular.forEach($scope.additionals['slots'], function (itemSlot, keySlot) {
                                if (!angular.isUndefined(itemSlot['order_ids'])) {
                                        var posOrder = itemSlot['order_ids'].map(function (e) {
                                            return e;
                                        }).indexOf(parseInt(model.id));
                                        if (posOrder >= 0) {
                                            pos = 1;
                                        }
                                }
                            });
                            if (pos == 0) {
                                $scope.createMarker(model);
                                $scope.additionals['ordersAll'].push(model);
                                $scope.additionals['ordersAll'] = $filter('orderBy')($scope.additionals['ordersAll'], 'order_start');
                                $scope.additionals['ordersAll'] = $scope.additionals['uniqueArray']($scope.additionals['ordersAll']);
                            }
                        }
                    }
                    if (position >= 0) {
                        if (model.shipping_method_id == "1") {
                            $scope.additionals['ordersAll'][position] = model;
                            $scope.markers[model.id] = model;
                        } else {
                            $scope.additionals['ordersAll'].splice(position, 1);
                            //delete $scope.markers[model.order_no];
                            if (!angular.isUndefined($scope.markers[model.order_no])) {
                                $scope.map.removeLayer($scope.markers[model.order_no]);
                            }
                        }
                    }
                    $scope.ordersAll = $scope.additionals['ordersAll'];
                }

                if (ex_status == 1) {
                    if (!angular.isUndefined($scope.modelsOrdersActive)) {
                        var positionOrdersActive = $scope.modelsOrdersActive.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionOrdersActive >= 0) {
                            $scope.modelsOrdersActive.splice(positionOrdersActive, 1);
                            if ($scope.modelsOrdersActive.length <= 0) {
                                var no_pagesOrdersActive = Math.ceil(($scope.totalOrdersActive - 1) / perPageOrdersActive);
                                if ($scope.modelsOrdersActive.current_page > no_pagesOrdersActive) {
                                    $scope.modelsOrdersActive.current_page = no_pagesOrdersActive;
                                }
                                if (angular.isUndefined($scope.modelsOrdersActive.current_page) || $scope.modelsOrdersActive.current_page == 0) {
                                    $scope.modelsOrdersActive.current_page = 1;
                                }
                                $scope.getOrdersActive($scope.path, $scope.modelsOrdersActive.current_page, perPageOrdersActive);
                            }
                        }
                    }
                }

            } else {
                if (!angular.isUndefined($scope.additionals['ordersAll'])) {
                    var position = $scope.additionals['ordersAll'].map(function (e) {
                        return e['id'];
                    }).indexOf(parseInt(model.id));
                    if (position >= 0) {
                        $scope.additionals['ordersAll'].splice(position, 1);
                        //delete $scope.markers[model.order_no];
                        if (!angular.isUndefined($scope.markers)) {
                            if (!angular.isUndefined($scope.markers[model.order_no])) {
                                $scope.map.removeLayer($scope.markers[model.order_no]);
                            }
                        }
                        $scope.ordersAll = $scope.additionals['ordersAll'];
                    }
                }
                if (current_status == 1) {
                    if (ex_status == 1) {
                        if (!angular.isUndefined($scope.modelsOrdersActive)) {
                            var positionOrdersActive = $scope.modelsOrdersActive.map(function (e) {
                                return e['id'];
                            }).indexOf(parseInt(model.id));
                            if (positionOrdersActive >= 0) {
                                if (model.shipping_method_id == "1") {
                                    $scope.modelsOrdersActive[positionOrdersActive] = model;
                                      if (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') != moment(model.order_planning).format('DD/MM/YYYY')) {
                                        $scope.modelsOrdersActive.splice(positionOrdersActive, 1);
                                      }
                                } else {
                                    $scope.modelsOrdersActive.splice(positionOrdersActive, 1);
                                }
                            } else {
                                if (model.shipping_method_id == "1" && ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && angular.isUndefined(model['order_planning']) || model['order_planning'] == null) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY'))   ) ) {
                                    if (!angular.isUndefined($scope.fromOrdersActive)) {
                                        $scope.fromOrdersActive = 1;
                                    }
                                    $scope.modelsOrdersActive.push(model);
                                }

                            }
                        }
                    } else {

                        if (!angular.isUndefined($scope.modelsOrdersActive)) {
                            var positionOrdersActive = $scope.modelsOrdersActive.map(function (e) {
                                return e['id'];
                            }).indexOf(parseInt(model.id));
                            if (positionOrdersActive < 0) {
                                if (model.shipping_method_id == "1" && ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && angular.isUndefined(model['order_planning']) || model['order_planning'] == null) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY'))   ) ) {
                                    if (!angular.isUndefined($scope.fromOrdersActive)) {
                                        $scope.fromOrdersActive = 1;
                                    }
                                    $scope.modelsOrdersActive.push(model);
                                    $scope.modelsOrdersActive = $filter('orderBy')($scope.modelsOrdersActive, 'order_start');

                                    var current_page = $scope.modelsOrdersActive.current_pageOrdersActive;
                                    $scope.modelsOrdersActive = $scope.additionals['uniqueArray']($scope.modelsOrdersActive);
                                    $scope.modelsOrdersActive.current_pageOrdersActive = current_page;
                                }

                            }
                        }

                    }
                } else {
                    if (!angular.isUndefined($scope.modelsOrdersActive)) {
                        var positionOrdersActive = $scope.modelsOrdersActive.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionOrdersActive >= 0) {
                            $scope.modelsOrdersActive.splice(positionOrdersActive, 1);
                            if ($scope.modelsOrdersActive.length <= 0) {
                                var no_pagesOrdersActive = Math.ceil(($scope.totalOrdersActive - 1) / perPageOrdersActive);
                                if ($scope.modelsOrdersActive.current_page > no_pagesOrdersActive) {
                                    $scope.modelsOrdersActive.current_page = no_pagesOrdersActive;
                                }
                                if (angular.isUndefined($scope.modelsOrdersActive.current_page) || $scope.modelsOrdersActive.current_page == 0) {
                                    $scope.modelsOrdersActive.current_page = 1;
                                }
                                $scope.getOrdersActive($scope.path, $scope.modelsOrdersActive.current_page, perPageOrdersActive);
                            }
                        }
                    }
                }

            }

        }

        Mqtt.addListener({'id': 'order_status', 'funct': statusOrder});
        function statusOrder(result, channel) {
            //console.log(channel)
            //console.log(result)

            if (channel == 'order_status') {

                if(result[0]['amount_driver_cash'] > 0){
                         if (angular.isUndefined($scope.notificationsAll[result[0]['driver_id']])) {
                                $scope.notificationsAll[result[0]['driver_id']] = {};
                         }
                        $scope.notificationsAll[result[0]['driver_id']]['driver_id'] = result[0]['driver_id'];
                        $scope.notificationsAll[result[0]['driver_id']]['amount_driver_cash'] = result[0]['amount_driver_cash'];
                        $scope.notificationsAll[result[0]['driver_id']]['driver_name'] = result[0]['driver_name'];

                         $timeout($scope.additionals['openNotification'], 1000);
                }

                var model = result[0];
                if (!angular.isUndefined($scope.models)) {
                    var positionSlot = $scope.models.map(function (e) {
                        return e['id'];
                    }).indexOf(parseInt(model.slot_id));
                    if (positionSlot >= 0) {
                        var positionOrder = $scope.models[positionSlot]['orders'].map(function (e) {
                            return e['order_id'];
                        }).indexOf(parseInt(model.order_id));
                        if (positionOrder >= 0) {
                            $scope.models[positionSlot]['orders'][positionOrder]['order_status'] = model['order_status'];
                            $scope.models[positionSlot]['orders'][positionOrder]['reason_nondelivery'] = model['reason_nondelivery'];
                        }

                    }
                }

            }
            if (channel == 'order_updated') {
                //console.log(channel)
                //console.log(result)
                var model = result;
                if (!angular.isUndefined($scope.models)) {
                    var positionSlot = $scope.models.map(function (e) {
                        return e['id'];
                    }).indexOf(parseInt(model.slot_id));
                    if (positionSlot >= 0) {
                        var positionOrder = $scope.models[positionSlot]['orders'].map(function (e) {
                            return e['order_id'];
                        }).indexOf(parseInt(model.id));
                        if (positionOrder >= 0) {
                            $scope.models[positionSlot]['orders'][positionOrder]['order_status'] = model['order_status'];
                            $scope.models[positionSlot]['orders'][positionOrder]['reason_nondelivery'] = model['reason_nondelivery'];
                        }

                    }
                }

            }
        }

        Mqtt.addListener({'id': 'slot_status', 'funct': statusSlot});
        function statusSlot(result, channel) {
            // console.log(channel)
            // console.log(result)

            var model = result[0];
            if (channel == 'slot_status') {
                if (!angular.isUndefined($scope.models)) {
                    var positionUpdated = $scope.models.map(function (e) {
                        return e['id'];
                    }).indexOf(parseInt(model.id));
                    if (positionUpdated >= 0) {
                        $scope.models[positionUpdated]['slot_status'] = model['slot_status'];
                        $scope.models[positionUpdated]['amount_dispatcher_cash_collected'] = model['amount_dispatcher_cash_collected'];
                        $scope.models[positionUpdated]['amount_dispatcher_card_collected'] = model['amount_dispatcher_card_collected'];
                        $scope.models[positionUpdated]['amount_driver_cash_required'] = model['amount_driver_cash_required'];
                        if (model['orders']) {
                            angular.forEach(model['orders'], function (item, key) {
                                if ($scope.models[positionUpdated]['orders'][key]['order_id'] == model['orders'][key]['order_id']) {
                                    $scope.models[positionUpdated]['orders'][key]['order_status'] = model['orders'][key]['order_status'];
                                    $scope.models[positionUpdated]['orders'][key]['reason_nondelivery'] = model['orders'][key]['reason_nondelivery'];
                                }
                            });
                        }
                    }
                }

            }
        }

        Mqtt.addListener({'id': 'slot', 'funct': arrivedSlot});
        function arrivedSlot(result, channel) {
            // console.log(channel)
            // console.log(result)

            if (channel == 'order_updated') {
                $scope.mqttUpdateOrderDelivery(result, result.current_status, result.ex_status);
            }

            if (channel == 'many_orders') {
                $scope.mqttUpdateManyOrdersDelivery(result);
            }

            if (channel == 'slot_updated') {
              //console.log($scope.models)
                if (!angular.isUndefined($scope.models)) {
                    var positionUpdated = $scope.models.map(function (e) {
                        return e['id'];
                    }).indexOf(parseInt(result[0]['id']));
                    if (positionUpdated >= 0) {
                        $scope.models[positionUpdated] = result[0];
                    }
                }
            }
        }
        /* end mqtt */

        $scope.additionals['addOrderPackets'] = function (ev, orderId, orderPackets) {
            /*on enter*/
            var post = {};
            post['route'] = 'addOrderPackets';
            post['order_id'] = orderId;
            post['order_packets'] = orderPackets;
            Crud.post('form-urlencoded', post, $scope.path + '/addOrderPackets')
                    .success(function (data) {
                        $scope.modelDataOrder['order_packets'] = data['order_packets'];
                        $scope.errors = [];
                    }).error(function (data) {
                        $scope.errors = data.errors;
                    });

        }

        /*$scope.getSlotss = function () {
         var post = {};
         post['route'] = 'search';
         post['driver_phone'] = '0755336631';
         post['driver_token'] = 'V6EIngkrjL';
         post['slot_status'] = 0;
         Crud.post('form-urlencoded', post, '/api/searchAllSlotsDriver')
         .success(function (data) {
         console.log(data)
         });
         }
         channel.bind('App\\Events\\AppTaxi', function (response) {
         $scope.getSlotss();
         });*/

        /* get orders active */
        $scope.columnsOrdersActive = {
            'street_name': {'label': 'Strada', 'filter': 1, 'filterType': 'input'},
            'address_no': {'label': 'Nr.str.', 'filter': 1, 'filterType': 'input'},
            'section_name': {'label': 'Cart.', 'filter': 1, 'filterType': 'input'},
            'locality_name': {'label': 'Loc.', 'filter': 1, 'filterType': 'input'},
            'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
            'client_name': {'label': 'Client', 'filter': 1, 'filterType': 'input'},
            'payment_method_name': {'label': 'Plata', 'filter': 1, 'filterType': 'select'},
            'order_phone': {'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
            'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
            'order_total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            'order_start': {'label': 'Start', 'filter': 1, 'filterType': 'input'},
            //'order_end':{'label': 'End', 'filter': 1, 'filterType': 'input'},
            //'order_status':{'label': 'Status', 'filter': 1, 'filterType': 'select'},
            'timer': {'label': 'Timer', 'filter': 0, 'filterType': 'input'},
            'created_by': {'label': 'Adaugat', 'filter': 1, 'filterType': 'input'}
        };
        $scope.orderStatus = {};
        $scope.orderStatus.options = [
            {'id': 0, 'value': 'Preluata', 'color': 'rgba(217, 217, 217, 0.9)', 'color-even': 'rgba(217, 217, 217, 0.5)'}, //gray
            {'id': 1, 'value': 'Derulare', 'color': 'rgba(242, 237, 86, 0.9)', 'color-even': 'rgba(242, 237, 86, 0.7)'}, //yellow
            {'id': 2, 'value': 'Anulata', 'color': 'rgba(193, 32, 38, 0.5)', 'color-even': 'rgba(193, 32, 38, 0.3)'}, //red
            {'id': 3, 'value': 'Trimisa spre livrare', 'color': 'rgba(222, 96, 27, 0.5)', 'color-even': 'rgba(222, 96, 27, 0.3)'}, //brown
            {'id': 4, 'value': 'Curs de livrare', 'color': 'rgba(169, 215, 65, 0.9)', 'color-even': 'rgba(169, 215, 65, 0.7)'}, //green
            {'id': 5, 'value': 'Livrata', 'color': 'rgba(0, 51, 153, 0.4)', 'color-even': 'rgba(0, 51, 153, 0.2)'}, //blue
            {'id': 6, 'value': 'Anulata sofer', 'color': 'rgba(90, 87, 87, 0.8)', 'color-even': 'rgba(90, 87, 87, 0.6)'},//black
            {'id': 7, 'value': 'Stand by', 'color': 'rgba(160, 160, 160, 0.8)', 'color-even': 'rgba(160, 160, 160, 0.6)'}//dark grey
        ];
        $scope.columnsOrdersActive.order_source.options = [
            {'id': '', 'value': ''},
            {'id': 0, 'value': 'Directa', 'icon': $scope.additionals['publicAppPath'] + '/direct.png'},
            {'id': 1, 'value': 'Telefon', 'icon': $scope.additionals['publicAppPath'] + '/phone.png'},
            {'id': 2, 'value': $rootScope.nameProject, 'icon': $scope.additionals['publicAppPath'] + '/logo_ssmall.png'},
            {'id': 3, 'value': 'HipMenu', 'icon': $scope.additionals['publicAppPath'] + '/hipmenu.png'},
            {'id': 4, 'value': 'FoodPanda', 'icon': $scope.additionals['publicAppPath'] + '/foodpanda.png'},
            {'id': 5, 'value': 'Tazz', 'icon': $scope.additionals['publicAppPath'] + '/tazz.png'},
            {'id': 6, 'value': 'Glovo', 'icon': $scope.additionals['publicAppPath'] + '/glovo.png'},
            {'id': 7, 'value': 'Takeaway', 'icon': $scope.additionals['publicAppPath'] + '/takeaway.png'}
        ];

        /* get dependent fields */
        $scope.getDependedFields = function () {
            Crud.getDependedFields($scope.path)
                .success(function (data) {

                    $scope.additionals['kitchens'] = data.kitchens;

                    $scope.additionals['order_discount_reasons'] = data.discountsReasons;
                    if (!angular.isUndefined($scope.additionals['order_discount_reasons'])) {
                      $scope.additionals['order_discount_reason_string'] = JSON.stringify($scope.additionals['order_discount_reasons']);
                    }

                    $scope.additionals['payment_methods'] = data.paymentMethods;

                    if (!angular.isUndefined($scope.columnsOrdersActive.payment_method_name)) {
                        $scope.columnsOrdersActive.payment_method_name.options = [{id: '', value: ''}];
                        angular.forEach(data.paymentMethods, function (item, key) {
                            $scope.columnsOrdersActive.payment_method_name.options.push({
                                id: item.payment_method_name,
                                value: item.payment_method_name
                            });
                        });

                        if (!angular.isUndefined($scope.columnsOrdersActive.payment_method_name)) {
                          $scope.additionals['payment_method_name_string'] = JSON.stringify($scope.columnsOrdersActive.payment_method_name.options);
                        }

                    }

                });
        }

        var perPageOrdersActive = 15;
        $scope.modelsOrdersActive = [];
        $scope.fromOrdersActive = 1;
        $scope.current_pageOrdersActive = [];
        $scope.last_pageOrdersActive = [];
        $scope.totalOrdersActive = [];
        $scope.getOrdersActive = function (path, offset, per_page) {

            if (angular.isUndefined(per_page) || per_page == 'undefined') {
                per_page = perPageOrdersActive;
            }

            $scope.additionals['buttonDisabledPagination'] = true;
            $scope.rangeOrdersActive = [];
            if (angular.isUndefined($scope.no_pagesOrdersActive)) {
                $scope.no_pagesOrdersActive = 1;
            }
            $scope.isLoadingPaginationOrdersActive = true;
            $scope.$watch('no_pagesOrdersActive', function (item) {
                item = $scope.no_pagesOrdersActive;
            }, true);

            var pathOrder = $scope.path + '/getOrdersActive?page=' + offset + '&per_page=' + per_page;
            var crud = Crud.get(pathOrder);
            crud.success(function (data) {
                if (!angular.isUndefined(data.invalid)) {
                    $scope.additionals['invalid'] = data.invalid;
                } else {
                    $scope.stopOrdersActive = data.next_page_url;
                    $scope.fromOrdersActive = data.from;
                    $scope.toOrdersActive = data.to;
                    $scope.totalOrdersActive = data.total;
                    $scope.no_pagesOrdersActive = Math.ceil(data.total / data.per_page);

                    if (per_page == 0) {
                        $scope.rangeOrdersActive = [{}];
                    } else {
                        for (var i = 0; i < $scope.no_pagesOrdersActive; i++) {
                            $scope.rangeOrdersActive[i] = i;
                        }
                    }

                    $scope.modelsOrdersActive = data.data;
                    $scope.modelsOrdersActive.perPageOrdersActive = data.per_page;
                    $scope.modelsOrdersActive.current_pageOrdersActive = data.current_page;
                }
                $scope.isLoadingPaginationOrdersActive = false;
                $scope.additionals['buttonDisabledPagination'] = false;
            });

        };
        if ($location.path() == $scope.path) {
            $scope.getOrdersActive($scope.path, 1, perPageOrdersActive);
        }

        $scope.printOrder = function (ev, path, modelId, doc) {
            var post = {};
            post['id'] = modelId;
            post['route'] = 'printOrder';
            post['doc'] = doc;
            $scope.additionals['buttonDisabled'] = true;
            Crud.post('form-urlencoded', post, path + '/printOrder')
                    .success(function (data) {
                        $scope.additionals['buttonDisabled'] = false;
                    })
                    .error(function (data) {

                        $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'printOrderDialog.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: {pathTemplate: $scope.pathTemplate, error: data, additionals: $scope.additionals}
                        });
                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'error', 'additionals'];
                        function DialogController($scope, $mdDialog, pathTemplate, error, additionals) {
                            $scope.pathTemplate = pathTemplate;
                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };
                            $scope.additionals = additionals;
                            $scope.additionals['buttonDisabled'] = false;

                            $scope.errors = error;
                        }
                    });
        }

        /* show model order*/
        $scope.showOrderActive = function (ev, path, orderId, key) {
            /* key is index model */
            if (!angular.isUndefined(key)) {
                $scope.additionals['indexModel'] = key;
            }
            $scope.additionals['buttonDisabled'] = true;
            if ($scope.mode_action == 'page') {
                $scope.mode_action_order = 'page';
                $scope.controlSHOrder = true;
                $scope.action_order = 'showOrderActive';

                var heightMap = $('.app-map-center').height();
                if (!angular.isUndefined(heightMap)) {
                    heightMap = heightMap + 500;
                } else {
                    heightMap = 500;
                }
                angular.element(document.querySelector('.fill-height')).animate({scrollTop: heightMap}, "slow");

                $scope.modelDataOrderActive = {};
                $scope.cancel = function () {
                    $scope.modelDataOrderActive = {};
                    $scope.additionals.modelDataOrderActive = {};
                    $scope.errors = {};
                    $scope.controlSHOrder = false;

                };
                Crud.get($scope.path + '/showOrder?order_id=' + orderId)
                        .success(function (data) {
                            $scope.modelDataOrderActive = data;
                            $scope.additionals.modelDataOrderActive = $scope.modelDataOrderActive;
                            $scope.additionals['calcProcess'](data, 'OrderActive');
                            $scope.additionals['buttonDisabled'] = false;
                        });
            }
            if ($scope.mode_action == 'dialog') {
                Crud.get($scope.path + '/showOrder?order_id=' + orderId)
                    .success(function (data) {
                        if (!angular.isUndefined(data['order_start']) && !angular.isUndefined(data['validated_at'])) {
                            $scope.additionals['dispatchTimeOrderActive'] = $scope.additionals['diffDatesMinutes'](data['order_start'], data['validated_at']);
                        }

                        if (!angular.isUndefined(data['order_planning']) && data['order_planning'] != null && data['order_planning'] != 'null' && data['order_planning'] != '' && !angular.isUndefined(data['validated_at']) && data['validated_at'] != null && data['validated_at'] != 'null') {
                                $scope.additionals['kitchenTimeOrderActive'] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['order_planning'].substring(0, 10)+' '+$scope.additionals['calcPlannedTime'](data['order_planning'], data['planned_time']));
                                 if (!angular.isUndefined(data['processed_at'])) {
                                    $scope.additionals['plannedTimeOrderActive'] = $scope.additionals['diffDatesMinutes'](data['order_planning'].substring(0, 10)+' '+$scope.additionals['calcPlannedTime'](data['order_planning'], data['planned_time']), data['processed_at']);
                                }
                       } else {
                            if (!angular.isUndefined(data['processed_at']) && !angular.isUndefined(data['validated_at'])) {
                                    $scope.additionals['kitchenTimeOrderActive'] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['processed_at']);
                                }
                       }

                        if (!angular.isUndefined(data['delivered_at']) && !angular.isUndefined(data['processed_at'])) {
                            $scope.additionals['distributionTimeOrderActive'] = $scope.additionals['diffDatesMinutes'](data['processed_at'], data['delivered_at']);
                        }
                        if (!angular.isUndefined(data['order_end']) && !angular.isUndefined(data['delivered_at'])) {
                            $scope.additionals['deliveryTimeOrderActive'] = $scope.additionals['diffDatesMinutes'](data['delivered_at'], data['order_end']);
                        }

                        $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'showDialogOrderActive.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: {
                                pathTemplate: $scope.pathTemplate,
                                model: data,
                                formatText: $scope.formatText,
                                formatDate: $scope.formatDate,
                                columns: $scope.columns,
                                additionals: $scope.additionals
                            },
                        });
                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'formatText', 'formatDate', 'columns', 'additionals'];
                        function DialogController($scope, $mdDialog, pathTemplate, model, formatText, formatDate, columns, additionals) {
                            $scope.pathTemplate = pathTemplate;
                            $scope.modelDataOrderActive = model;
                            $scope.additionals = additionals;
                            $scope.additionals.modelDataOrderActive = $scope.modelDataOrderActive;
                            $scope.formatText = formatText;
                            $scope.formatDate = formatDate;
                            $scope.columns = columns;
                            $scope.currency = $rootScope.currency;

                            $scope.cancel = function () {
                                $scope.modelDataOrderActive = {};
                                $scope.additionals.modelDataOrderActive = {};
                                $mdDialog.cancel();
                            };
                        }
                        $scope.additionals['buttonDisabled'] = false;
                        }).error(function (data) {
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                        });
            }
        };

        $scope.getOrdersEdit = function (slotId) {
            Crud.get($scope.path + '/getOrdersEdit?slotId=' + slotId)
                    .success(function (data) {
                        $scope.additionals['ordersAllEdit'] = data.orders;
                    });
        }

        /* get drivers */
        $scope.getDrivers = function (keySlot) {
            Crud.get($scope.path + '/getDrivers')
                    .success(function (data) {
                        if (angular.isUndefined($scope.additionals['drivers'])) {
                            $scope.additionals['drivers'] = [];
                        }
                        $scope.additionals['driversAll'] = data.drivers;
                        $scope.additionals['drivers'][keySlot] = data.drivers;
                        if ($location.path() == $scope.path + '/reportActivity') {
                            $scope.search.driver_id = $scope.additionals['driversAll'][0]['id'];
                        }
                    });
        }
        $scope.getDrivers(0);

        $scope.additionals['searchTermOrder'];
        $scope.additionals['clearSearchTermOrder'] = function () {
            $scope.additionals['searchTermOrder'] = '';
        };
        $scope.additionals['onSearchChangeOrder'] = function (ev) {
            ev.stopPropagation();
        };

        $scope.additionals['searchTermDriver'];
        $scope.additionals['clearSearchTermDriver'] = function () {
            $scope.additionals['searchTermDriver'] = '';
        };
        $scope.additionals['onSearchChangeDriver'] = function (ev) {
            ev.stopPropagation();
        };

        $scope.additionals['searchTermDriverSingle'];
        $scope.additionals['clearSearchTermDriverSingle'] = function () {
            $scope.additionals['searchTermDriverSingle'] = '';
        };
        $scope.additionals['onSearchChangeDriverSingle'] = function (ev) {
            ev.stopPropagation();
        };

        $scope.additionals['selectOrder'] = function (keySlot, modelData) {
            $scope.additionals['orders'][keySlot] = $scope.additionals['ordersAll'].filter(function (item) {
                var control = true;
                angular.forEach(modelData.slots, function (items, key) {
                    if (key != keySlot) {
                        angular.forEach(items['order_ids'], function (itemsId, keyId) {
                            if (item.id.toString().indexOf(itemsId) > -1) {
                                control = false;
                            }
                        });
                    }
                });
                return control;
            });
            if (!angular.isUndefined($scope.additionals['slots'][keySlot])) {
                $scope.additionals['orders'][keySlot] = $scope.additionals['orders'][keySlot].concat($scope.additionals['slots'][keySlot]['orders']);
            }
        }

        $scope.additionals['isInArray'] = function (value, array) {
            return array.indexOf(value) > -1;
        }
        $scope.additionals['changeOrder'] = function (keySlot, ids) {
            var idsSlot = [];
            if (angular.isUndefined($scope.additionals['slots'][keySlot]['orders'])) {
                $scope.additionals['slots'][keySlot]['orders'] = [];
            }
            if ($scope.additionals['slots'][keySlot]['orders'].length > 0) {
                angular.forEach($scope.additionals['slots'][keySlot]['orders'], function (item, key) {
                    idsSlot[key] = item.id;
                });
            }

            if ($scope.additionals['controlRemoveItem'] == 0) {
                if (ids.length > 0) {
                    angular.forEach(ids, function (item, key) {
                        if (!$scope.additionals['isInArray'](item, idsSlot)) {
                            var position = $scope.additionals['ordersAll'].map(function (e) {
                                return e['id'];
                            }).indexOf(item);

                           if(position >= 0){
                                     if (!angular.isUndefined($scope.additionals['ordersAll'][position])) {
                                            if (!angular.isUndefined($scope.markers[$scope.additionals['ordersAll'][position].order_no]) && !angular.isUndefined($scope.additionals['ordersAll'][position].order_no) ){
                                                $scope.map.removeLayer($scope.markers[$scope.additionals['ordersAll'][position].order_no]);
                                            }
                                    }
                                    if (!angular.isUndefined($scope.additionals['slots'][keySlot])) {
                                        $scope.additionals['slots'][keySlot]['orders'].push($scope.additionals['ordersAll'][position]);
                                        $scope.additionals['slots'][keySlot]['order_ids'] = ids;
                                    }
                                    $timeout(function () {
                                         //delete $scope.markers[$scope.additionals['ordersAll'][position].order_no];
                                         $scope.additionals['ordersAll'].splice(position, 1);
                                    }, 200);

                            }
                        }
                    });
                }
                if (idsSlot.length > 0) {
                    angular.forEach(idsSlot, function (item, key) {
                        if (!$scope.additionals['isInArray'](item, ids)) {
                            var position = $scope.additionals['slots'][keySlot]['orders'].map(function (e) {
                                return e['id'];
                            }).indexOf(item);
                            $scope.additionals['ordersAll'].push($scope.additionals['slots'][keySlot]['orders'][position]);
                            $scope.additionals['slots'][keySlot]['orders'].splice(position, 1);
                        }
                    });
                }
            }
            $timeout(function () {
                $scope.additionals['controlRemoveItem'] = 0;
            }, 200);
        }

        $scope.dropCallback = function (index, item, external, type, keySlot) {

            if (angular.isUndefined(keySlot)) {
                $scope.createMarker(item);
                $scope.modelData.slots = [];
            }
            if (angular.isUndefined($scope.modelData.slots)) {
                $scope.modelData.slots = [];
            }
            if (angular.isUndefined($scope.modelData.slots[keySlot])) {
                $scope.modelData.slots[keySlot] = {};
            }
            if (angular.isUndefined($scope.modelData.slots[keySlot].order_ids)) {
                $scope.modelData.slots[keySlot].order_ids = [];
            }
            if (angular.isUndefined($scope.modelData.slots[keySlot].orders)) {
                $scope.modelData.slots[keySlot].orders = [];
            }

            $scope.modelData.slots = [];
            $timeout(function () {
                $scope.idsMarkers = [];
                angular.forEach($scope.additionals['slots'], function (itemSlot, indexSlot) {
                    $scope.modelData.slots[indexSlot] = {};
                    $scope.modelData.slots[indexSlot]['driver_id'] = itemSlot['driver_id'];
                    $scope.modelData.slots[indexSlot].order_ids = [];
                    itemSlot['order_ids'] = [];

                    if (angular.isUndefined($scope.idsMarkers[indexSlot])) {
                        $scope.idsMarkers[indexSlot] = [];
                    }
                    if (itemSlot['orders'].length > 0) {
                        angular.forEach(itemSlot['orders'], function (itemOrder, keyOrder) {
                            if (angular.isUndefined(itemSlot['order_ids'])) {
                                itemSlot['order_ids'] = [];
                            }
                            itemSlot['order_ids'][keyOrder] = itemOrder.id;

                            //delete $scope.markers[itemOrder.order_no];
                            if (!angular.isUndefined($scope.markers)) {
                                if (!angular.isUndefined($scope.markers[itemOrder.order_no])) {
                                    $scope.map.removeLayer($scope.markers[itemOrder.order_no]);
                                }
                            }
                            $scope.modelData.slots[indexSlot].order_ids[keyOrder] = itemOrder.id;
                            $scope.additionals['selectOrder'](indexSlot, $scope.modelData);

                            itemSlot['order_ids'] = itemSlot['order_ids'].filter(function (item, i, ar) {
                                return ar.indexOf(item) === i;
                            });
                        });

                        $scope.idsMarkers[indexSlot] = itemSlot['order_ids'];
                    } else {
                        $scope.additionals['slots'][indexSlot].order_ids = [];
                        $scope.idsMarkers[indexSlot] = [];
                    }
                });
            }, 100);

            return item;
        };

        $scope.additionals['selectDriver'] = function (keySlot, modelData) {
            $scope.additionals['drivers'][keySlot] = $scope.additionals['driversAll'].filter(function (item) {
                var control = true;
                angular.forEach(modelData.slots, function (items, key) {
                    if (key != keySlot) {
                        if (item.id.toString().indexOf(items.driver_id) > -1) {
                            control = false;
                        }
                    }
                });
                return control;
            });

        }

        $scope.additionals['changeDriver'] = function (keySlot, modelData) {
            $scope.additionals['slots'][keySlot]['driver_id'] = modelData['slots'][keySlot]['driver_id'];
        }

        /* add multiple slots forms */
        $scope.additionals['slots'] = [{}];
        $scope.additionals['slots'][0].order_ids = [];
        $scope.additionals['cloneItem'] = function (model, modelLength) {
            var itemToClone = {};
            if (angular.isUndefined(itemToClone.orders)) {
                itemToClone.orders = [];
            }
            $scope.additionals[model].push(itemToClone);
            $scope.getLastSlot();
        }

        $scope.additionals['controlRemoveItem'] = 0;
        $scope.additionals['removeItem'] = function (itemIndex, modelSlot) {

            $rootScope.diplayMarker = 0;
            $scope.additionals['controlRemoveItem'] = 1;

            if (!angular.isUndefined($scope.additionals['slots'][itemIndex])) {
                //$scope.idsMarkers[itemIndex] = $scope.additionals['slots'][itemIndex].order_ids;

                angular.forEach($scope.additionals['slots'][itemIndex].orders, function (itemOrder, indexOrder) {
                    $scope.additionals['ordersAll'].push(itemOrder);
                    $scope.createMarker(itemOrder);
                });
            }
            if (!angular.isUndefined($scope.errors)) {
                if (!angular.isUndefined($scope.errors['slots.' + itemIndex + '.order_ids'])) {
                    delete $scope.errors['slots.' + itemIndex + '.order_ids'];
                }
                if (!angular.isUndefined($scope.errors['slots.' + itemIndex + '.driver_id'])) {
                    delete $scope.errors['slots.' + itemIndex + '.driver_id'];
                }
            }
            $scope.interm = [];
            angular.forEach($scope.additionals[modelSlot], function (itemy, indexy) {
                /*if(!angular.isUndefined(itemy['order_ids']) ) {
                 itemy['order_ids'] = [];
                 }*/
                $scope.interm[indexy] = {
                    'order_ids': itemy['order_ids'],
                    'orders': itemy['orders'],
                    'driver_id': itemy['driver_id']
                };
            });

            $scope.interms = [];
            angular.forEach($scope.interm, function (itemyy, indexyy) {
                $scope.interms.push({
                    'order_ids': itemyy['order_ids'],
                    'orders': itemyy['orders'],
                    'driver_id': itemyy['driver_id']
                });
            });
            $scope.interms.splice(itemIndex, 1);
            $scope.additionals[modelSlot] = $scope.interms;

            $timeout(function () {
                $scope.modelData.slots = $scope.additionals[modelSlot];

                if ($scope.additionals[modelSlot].length > 0) {
                    $scope.idsMarkers = [];
                    angular.forEach($scope.additionals[modelSlot], function (itemSl, indexSl) {
                        $scope.idsMarkers[indexSl] = $scope.additionals[modelSlot][indexSl].order_ids;

                        /*if(angular.isUndefined($scope.modelData.slots) ) {
                         $scope.modelData.slots[indexSl] = {};
                         }
                         $scope.modelData.slots[indexSl]['driver_id'] = itemSl['driver_id'];*/


                    });
                } else {
                    $scope.idsMarkers = [];
                }
                $scope.additionals['selectOrder'](itemIndex, $scope.modelData);

            }, 100);

        }

        /* close field */
        $scope.additionals['closeField'] = function (paramName, model, keySlot, key) {
            if (!angular.isUndefined(key)) {
                model[key][paramName] = '';
            } else {
                model.slots[keySlot][paramName] = '';
            }
        }

        $scope.additionals['function'] = function (ev, data) {

            if ($scope.action == 'update') {
                $scope.getOrdersEdit(data.id);
            }
            /*if($scope.action == 'update' || $scope.action == 'show') {
             var positionAction = $('.class-action').position();
             angular.element(document.querySelector('.fill-height')).animate({ scrollTop: positionAction.top }, "slow");
             }*/
            $scope.getLastSlot();
            var currentModel = {};
            angular.forEach(data, function (item, key) {
                switch (key) {
                    case 'slots':
                        if (angular.isUndefined($scope.additionals['slots']) || $scope.additionals['slots'].length == 0) {
                            currentModel['slots'] = [];
                        } else {
                            currentModel['slots'] = $scope.additionals['slots'];
                        }
                        angular.forEach(item, function (itemSlot, keySlot) {
                            if (angular.isUndefined(currentModel['slots'][keySlot])) {
                                currentModel['slots'][keySlot] = {};
                            }
                            angular.forEach(itemSlot, function (itemSlotDetail, keySlotDetail) {
                                currentModel['slots'][keySlot][keySlotDetail] = itemSlotDetail;
                            });
                        });
                        break;
                    default:
                        currentModel[key] = item;
                        break;
                }
            });

            $scope.modelData = currentModel;
            angular.forEach($scope.modelData.orders, function (itemModel, keyModel) {
                if (angular.isUndefined($scope.modelData.order_ids)) {
                    $scope.modelData.order_ids = [];
                }
                $scope.modelData.order_ids[keyModel] = itemModel.order_id;
            });

            if (!angular.isUndefined($scope.additionals['slots'])) {
                currentModel.slots = $scope.additionals['slots'];
            }
            if (angular.isUndefined(currentModel.slots) || currentModel.slots.length == 0) {
                currentModel.slots = [{}];
            }
            $scope.additionals['slots'] = currentModel.slots;
            if (angular.isUndefined($scope.additionals['slots'][0].order_ids)) {
                $scope.additionals['slots'][0].order_ids = [];
            }
            if (angular.isUndefined($scope.additionals['slots'][0].orders)) {
                $scope.additionals['slots'][0].orders = [];
            }
        }
        $scope.additionals['function']('', {});

        $scope.additionals['functionResult'] = function (ev, data) {
            //$scope.getLastSlot();
            //$scope.additionals['slots'] = [];
            if ($scope.state.page == 0) {
                $scope.state.page = 1;
            }

            if ($scope.additionals['slots'].length == 0) {
                $scope.additionals['cloneItem']('slots', 1);
            } else {
                $scope.getLastSlot();
            }
            $scope.getOrders();
            $timeout($scope.additionals['openNotification'], 1000);

        }

        $scope.isLoadingSlot = [];
        $scope.createSlot = function (ev, path, keySlot) {
            $scope.additionals['buttonDisabled'] = true;
            $scope.isLoadingSlot[keySlot] = true;
            $scope.modelData['field'] = $scope.search['field'];
            $scope.modelData['order'] = $scope.search['order'];

            if ($scope.additionals['content_type'] == 'form-urlencoded') {
                $scope.post = {};
                if (angular.isUndefined($scope.post['slots'])) {
                    $scope.post['slots'] = [];
                }
                if (angular.isUndefined($scope.post['slots'][keySlot])) {
                    $scope.post['slots'][keySlot] = {};
                }
                $scope.post['slots'][keySlot]['order_ids'] = [];
                angular.forEach($scope.additionals['slots'][keySlot].orders, function (item, index) {
                    $scope.post['slots'][keySlot]['order_ids'][index] = item.id;
                });
                if (angular.isUndefined($scope.modelData.slots)) {
                    $scope.modelData.slots = [];
                }
                if (!angular.isUndefined($scope.modelData.slots[keySlot])) {
                    $scope.post['slots'][keySlot].driver_id = $scope.modelData.slots[keySlot].driver_id;
                }

                $scope.post['route'] = 'store';
                $scope.post['keySlot'] = keySlot;
            }
            Crud.save($scope.additionals['content_type'], $scope.post, path)
                    .success(function (data) {
                        if (!angular.isUndefined(data.invalid)) {
                            $scope.additionals['invalid'] = data.invalid;
                        } else {
                            $scope.getOrders();
                            $scope.additionals['slots'].splice(keySlot, 1);
                            if ($scope.additionals['slots'].length == 0) {
                                $scope.additionals['cloneItem']('slots', 1);
                            } else {
                                $scope.getLastSlot();
                            }
                            /*if (!angular.isUndefined(data.position)) {
                             var no_pages = Math.ceil((data.position + 1) / $scope.state.itemsPerPage);
                             } else {
                             var no_pages = Math.ceil(($scope.total + 1) / $scope.state.itemsPerPage);
                             }
                             if ($scope.state.itemsPerPage == 0) {
                             if (!angular.isUndefined(data.position) && !angular.isUndefined(data.currentModel)) {
                             $scope.models.splice(data.position, 0, data.currentModel);
                             } else {
                             $scope.getPaginateModel(path, no_pages, $scope.state.itemsPerPage);
                             }
                             }
                             if ($scope.state.itemsPerPage != 0) {
                             $scope.getPaginateModel(path, no_pages, $scope.state.itemsPerPage);
                             }*/
                            if ($scope.state.page == 0) {
                                $scope.state.page = 1;
                            }
                            if (!angular.isUndefined(data.currentModel) && $scope.state.page == 1 && (angular.isUndefined($scope.searchControl) || $scope.searchControl === false)) {
                                if ($scope.models.length == 0) {
                                    $scope.from = 1;
                                }
                                $scope.models.unshift(data.currentModel);
                            }

                            if (!angular.isUndefined(data.newDependentFields)) {
                                angular.forEach(data.newDependentFields, function (item, key) {
                                    if (item instanceof Array) {
                                        angular.forEach(item, function (itemArray, keyArray) {
                                            $scope.additionals[key].push(itemArray);
                                        });
                                    } else {
                                        $scope.additionals[key].push(item);
                                    }
                                });
                            }
                            //$timeout($scope.additionals['openNotification'], 1000);

                             $timeout(function () {
                                 $scope.additionals['openNotification']($scope.post['slots'][keySlot].driver_id);
                            }, 1000);

                            //$scope.modelData = {};
                            $scope.modelData['slots'] = $scope.additionals['slots'];

                            $scope.errors = {};
                            $scope.isLoadingSlot[keySlot] = false;
                            $scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;

                            if (data.currentModel) {
                                var post = {};
                                post['id'] = data.currentModel.id;
                                post['order_ids'] = data.currentModel.order_ids;
                                post['driver_name'] = data.currentModel.driver_name;
                                post['route'] = 'printSlot';

                                $scope.additionals['printSlot'](path, post);
                            }

                            if (!angular.isUndefined(data.controlTazz) && data.controlTazz.length != 0) {
                                  var post = {};
                                  post['control_tazz'] = data.controlTazz;
                                  post['route'] = 'responseTazz';
                                  $scope.additionals['responseTazzSlot'](path, post);
                            }
                            if (!angular.isUndefined(data.controlBigBelly) && data.controlBigBelly.length != 0) {
                                  var post = {};
                                  post['control_bigbelly'] = data.controlBigBelly;
                                  post['route'] = 'responseBigBelly';
                                  $scope.additionals['responseBigBellySlot'](path, post);
                            }

                        }

                    })
                    .error(function (data) {
                        $scope.isLoadingSlot[keySlot] = false;
                        $scope.errors = data.errors;

                        if (!angular.isUndefined($scope.additionals['functionErrors'])) {
                            $scope.additionals['functionErrors'](ev, data);
                        }
                        $scope.additionals['buttonDisabled'] = false;
                    });
        }

        $scope.additionals['responseTazzSlot'] = function (path, post) {
            Crud.post('form-urlencoded', post, path + '/responseTazz')
                .success(function (data) {
                });
        }

        $scope.additionals['responseBigBellySlot'] = function (path, post) {
            Crud.post('form-urlencoded', post, path + '/responseBigBelly')
                .success(function (data) {
                });
        }

        $scope.additionals['printSlot'] = function (path, post) {
            Crud.post('form-urlencoded', post, path + '/printSlot')
                    .success(function (dataPrint) {
                        if (!angular.isUndefined(dataPrint.errors_print)) {
                            if (dataPrint.errors_print != '') {

                                $mdDialog.show({
                                    controller: DialogController,
                                    templateUrl: 'printOrdersSlotDialog.tmpl.html',
                                    parent: angular.element(document.body),
                                    //targetEvent: ev,
                                    clickOutsideToClose: true,
                                    locals: {
                                        pathTemplate: $scope.pathTemplate,
                                        error: dataPrint,
                                        additionals: $scope.additionals
                                    }
                                }).then();
                                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'error', 'additionals'];

                                function DialogController($scope, $mdDialog, pathTemplate, error, additionals) {
                                    $scope.pathTemplate = pathTemplate;
                                    $scope.cancel = function () {
                                        $mdDialog.cancel();
                                    };
                                    $scope.additionals = additionals;
                                    $scope.additionals['buttonDisabled'] = false;

                                    $scope.errors_print = dataPrint.errors_print;
                                    $scope.errors = error;
                                }
                            }
                        }
                    })
                    .error(function (dataPrint) {

                    });
        }

        $scope.additionals['itemSelect'] = function (val) {
            $scope.tmp = val;
        }
        $scope.additionals['changeOrderIds'] = function () {
            if (!angular.isUndefined($scope.tmp)) {
                if ($scope.modelData['order_ids'].indexOf($scope.tmp.id) != -1) {
                    if ($scope.selectedList.indexOf($scope.tmp.id) != -1) {
                        $scope.selectedList.splice($scope.selectedList.indexOf($scope.tmp.id), 1);
                    }
                    $scope.selectedList.push($scope.tmp.id);

                } else {
                    if ($scope.selectedList.indexOf($scope.tmp.id) != -1) {
                        $scope.selectedList.splice($scope.selectedList.indexOf($scope.tmp.id), 1);
                    }
                }
                $scope.modelData['order_ids'] = $scope.selectedList;

            }
        }

        $scope.editSlot = function (ev, path, model, section) {
            $scope.selectedList = model['order_ids'];

            $scope.additionals['ordersAllEdit'] = [];
            if ($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'update';
                $scope.errors = {};

                if ($location.path() == '/slot') {
                    var positionAction = $('.class-action').position();
                    angular.element(document.querySelector('.fill-height')).animate({scrollTop: positionAction.top}, "slow");
                } else {
                    angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, "slow");
                }

                $scope.additionals['invalid'] = '';
                var currentModel = {};
                angular.forEach(model, function (item, key) {
                    currentModel[key] = item;
                });
                $scope.modelData = currentModel;

                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };

                if (!angular.isUndefined($scope.additionals['function'])) {
                    $scope.additionals['function'](ev, $scope.modelData);
                }

                $scope.updateModel = function () {
                    $scope.additionals['buttonDisabled'] = true;

                    if (!angular.isUndefined($scope.additionals['internFunction'])) {
                        $scope.additionals['internFunction'](ev, $scope.modelData);
                    }
                    $scope.isLoading = true;

                    Crud.update($scope.additionals['content_type'], $scope.modelData, $rootScope.typeId, path)
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                        $scope.additionals['functionResult'](ev, data);
                                    }
                                    /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                     $scope.selected[model[$rootScope.typeId]] = model;
                                     }*/
                                    if (!angular.isUndefined(data.currentModel)) {
                                        if (!angular.isUndefined($scope.models)) {
                                            $scope.getElement($scope.models, data.currentModel);
                                        }
                                        if (!angular.isUndefined($scope.modelData)) {
                                            $scope.modelData = data.currentModel;
                                        }
                                    } else {
                                        if (!angular.isUndefined($scope.models)) {
                                            $scope.getElement($scope.models, currentModel);
                                        }
                                        if (!angular.isUndefined($scope.modelData)) {
                                            $scope.modelData = currentModel;
                                        }
                                    }

                                    if (data.currentModel) {
                                        if (data.print_order_ids) {
                                            var post = {};
                                            post['id'] = data.currentModel.id;
                                            post['order_ids'] = data.print_order_ids;
                                            post['driver_name'] = data.currentModel.driver_name;
                                            post['route'] = 'printSlot';

                                            $scope.additionals['printSlot'](path, post);
                                        }
                                    }

                                    //$timeout($scope.additionals['openNotification'], 1000);
                                }
                                $scope.modelData = {};
                                $scope.errors = {};
                                $scope.isLoading = false;
                                $scope.controlSH = false;
                                $scope.additionals['buttonDisabled'] = false;

                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                            });
                };
            }
            if ($scope.mode_action == 'dialog') {

                $scope.additionals['invalid'] = '';
                $scope.errors = {};
                $scope.action = 'update';
                var currentModel = {};

                angular.forEach(model, function (item, key) {
                    currentModel[key] = item;
                });

                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'editDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        section: section,
                        model: currentModel,
                        selected: $scope.selected,
                        additionals: $scope.additionals,
                        action: $scope.action
                    }
                }).then(function () {
                    if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                        if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                            if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                            }
                            if (!angular.isUndefined($scope.modelData)) {
                                $scope.modelData = $scope.additionals['dataCurrentModel'];
                            }
                        } else {
                            if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                            }
                            if (!angular.isUndefined($scope.modelData)) {
                                $scope.modelData = currentModel;
                            }
                        }

                    }
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'section', 'model', 'selected', 'additionals', 'action'];
                function DialogController($scope, $mdDialog, pathTemplate, section, model, selected, additionals, action) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.modelData = model;
                    $scope.additionals = additionals;
                    $scope.selected = selected;
                    $scope.section = section;
                    $scope.action = action;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    if (!angular.isUndefined($scope.additionals['function'])) {
                        $scope.additionals['function'](ev, $scope.modelData);
                    }

                    $scope.updateModel = function () {
                        $scope.additionals['buttonDisabled'] = true;
                        if (!angular.isUndefined($scope.additionals['internFunction'])) {
                            $scope.additionals['internFunction'](ev, $scope.modelData);
                        }
                        $scope.isLoading = true;

                        Crud.update($scope.additionals['content_type'], model, $rootScope.typeId, path)
                                .success(function (data) {
                                    if (!angular.isUndefined(data.invalid)) {
                                        $scope.additionals['invalid'] = data.invalid;
                                    } else {
                                        if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                            $scope.additionals['functionResult'](ev, data);
                                        }
                                        /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                         $scope.selected[model[$rootScope.typeId]] = model;
                                         }*/
                                        if (!angular.isUndefined(data.currentModel)) {
                                            $scope.additionals['dataCurrentModel'] = data.currentModel;
                                            $scope.additionals['newDependentFields'] = data.newDependentFields;
                                        }

                                        if (data.currentModel) {
                                                if (data.print_order_ids) {
                                                    var post = {};
                                                    post['id'] = data.currentModel.id;
                                                    post['order_ids'] = data.print_order_ids;
                                                    post['driver_name'] = data.currentModel.driver_name;
                                                    post['route'] = 'printSlot';

                                                    $scope.additionals['printSlot'](path, post);
                                                }
                                            }

                                            $timeout($scope.additionals['openNotification'], 1000);

                                    }
                                    $scope.isLoading = false;
                                    $mdDialog.hide();
                                    $scope.additionals['buttonDisabled'] = false;

                                    /*if (data.errors_print != '') {

                                        $mdDialog.show({
                                            controller: DialogController,
                                            templateUrl: 'printOrdersSlotDialog.tmpl.html',
                                            parent: angular.element(document.body),
                                            targetEvent: ev,
                                            clickOutsideToClose: true,
                                            locals: {pathTemplate: $scope.pathTemplate, error: data, additionals: $scope.additionals}
                                        }).then(function (destroyModel) {
                                        });
                                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'error', 'additionals'];

                                        function DialogController($scope, $mdDialog, pathTemplate, error, additionals) {
                                            $scope.pathTemplate = pathTemplate;
                                            $scope.cancel = function () {
                                                $mdDialog.cancel();
                                            };
                                            $scope.additionals = additionals;
                                            $scope.additionals['buttonDisabled'] = false;

                                            $scope.errors = error;
                                            $scope.errors_print = data.errors_print;
                                        }
                                    }*/

                                })
                                .error(function (data) {
                                    $scope.isLoading = false;
                                    $scope.errors = data.errors;
                                    $scope.additionals['buttonDisabled'] = false;
                                });
                    };

                }
            }
        };

        /* print test slot */
        $scope.controlPrintTestSlot = $routeParams['p'];
        if ($rootScope.session.user['id'] == 1 && $scope.controlPrintTestSlot == 1) {
            $scope.printTestSlot = function (ev, path, model, section) {

                model['route'] = 'printTestSlot';
                var typeRequest = 'form-urlencoded';
                Crud.post(typeRequest, model, path + '/printTestSlot')
                        .success(function (data) {
                        })
                        .error(function (data) {

                        });

            };
        }
        /* end print test slot */

        $scope.maxDate = new Date();
        $scope.minDate = '2010-01-01';
        var current_init_date = new Date();
        current_init_date.setHours(0, 0, 0, 0);
        $scope.search.dateFrom = current_init_date;

        $rootScope.stopTimerOrderSlot = $interval(function () {
            if (!angular.isUndefined($scope.additionals.modelDataOrderActive) && Object.keys($scope.additionals.modelDataOrderActive).length !== 0) {
              $scope.additionals.timerShowOrderActive = $scope.additionals['timer']($scope.additionals.modelDataOrderActive.validated_at);
            }

            angular.forEach($scope.modelsOrdersActive, function (item, key) {
              item.timerOrderActive = $scope.additionals['timer'](item.validated_at);
            });

            angular.forEach($scope.additionals['ordersAll'], function (item, key) {
              item.timerOrder = $scope.additionals['timer'](item.validated_at);
            });

            angular.forEach($scope.additionals['slots'], function (itemSlot, keySlot) {
               angular.forEach(itemSlot.orders, function (item, key) {
                  item.timersOrderSlot = $scope.additionals['timer'](item.validated_at);
                });
            });

          }, 1000);

        $scope.additionals['order_status'] = [
            {'id': 2, 'value': 'Anulata', 'color': 'rgba(193, 32, 38, 0.5)', 'color-even': 'rgba(193, 32, 38, 0.3)'}, //red
            {'id': 4, 'value': 'Curs de livrare', 'color': 'rgba(169, 215, 65, 0.9)', 'color-even': 'rgba(169, 215, 65, 0.7)'}, //green
            {'id': 5, 'value': 'Livrata', 'color': 'rgba(0, 51, 153, 0.4)', 'color-even': 'rgba(0, 51, 153, 0.2)'}, //blue
            {'id': 6, 'value': 'Anulata sofer', 'color': 'rgba(90, 87, 87, 0.8)', 'color-even': 'rgba(90, 87, 87, 0.6)'},//black
            {'id': 7, 'value': 'Stand by', 'color': 'rgba(160, 160, 160, 0.8)', 'color-even': 'rgba(160, 160, 160, 0.6)'}//dark grey
        ];
        $scope.additionals['search_order_status'] = [
            {'id': 2, 'value': 'Anulata', 'color': 'rgba(193, 32, 38, 0.5)', 'color-even': 'rgba(193, 32, 38, 0.3)'}, //red
            {'id': 4, 'value': 'Curs de livrare', 'color': 'rgba(169, 215, 65, 0.9)', 'color-even': 'rgba(169, 215, 65, 0.7)'}, //green
            {'id': 5, 'value': 'Livrata', 'color': 'rgba(0, 51, 153, 0.4)', 'color-even': 'rgba(0, 51, 153, 0.2)'}, //blue
            {'id': 6, 'value': 'Anulata sofer', 'color': 'rgba(90, 87, 87, 0.8)', 'color-even': 'rgba(90, 87, 87, 0.6)'},//black
            {'id': 7, 'value': 'Stand by', 'color': 'rgba(160, 160, 160, 0.8)', 'color-even': 'rgba(160, 160, 160, 0.6)'}//dark grey
        ];

        $scope.addReason = function (keySlot, keyOrder) {
            $scope.controlReason = [];
            $scope.controlReason[keySlot] = [];
            $scope.controlReason[keySlot][keyOrder] = 1;
        }
        $scope.closeReason = function (keySlot, keyOrder) {
            $scope.controlReason = [];
        }

        $scope.fakeReqv = function () {
            Crud.get('api/getPaymentMethods')
                .success(function (data) {
                })
                .error(function (data) {
                });
        }

        $scope.fakeReql = function () {
            var post = {};
            var typeRequest = 'form-urlencoded';

            post['route'] = 'login';
            post['driver_phone'] = '0749313571';
            post['driver_password'] = '123456';
            post['device_version'] = '2.0.23';

            Crud.post(typeRequest, post, 'api/login')
                .success(function (data) {
                })
                .error(function (data) {
                });
        }

        $scope.fakeReq = function () {
            var post = {};
            var typeRequest = 'form-urlencoded';

            post['route'] = 'changeStatusOrder';
            post['driver_phone'] = '0749313571';
            post['driver_token'] = 'cbHdWTf0l9';//cbHdWTf0l9//'kMi0oGL2fq';//'HozwD4YLQP';
            post['order_status'] = 5; //5 sau 6 sau 7
            post['slot_id'] = 394813;
            post['order_id'] = 962842;
            post['payment'] = 'cash';//cash sau card
            post['reason_nondelivery'] = 'pam pam 333';
            post['finished'] = [0, 1];

            Crud.post(typeRequest, post, 'api/changeStatusOrder')//searchOrdersDriver//changeStatusOrder
                .success(function (data) {
                })
                .error(function (data) {
                });
        }
        $scope.fakeReq0 = function () {
            var post = {};
            var typeRequest = 'form-urlencoded';

            post['route'] = 'search';
            post['driver_phone'] = '0749313571';
            post['driver_token'] = 'HozwD4YLQP';//'kMi0oGL2fq';//'HozwD4YLQP';

            post['dateFrom'] = "2024-06-17T04:00:00z";
            post['dateTo'] = "2024-06-18T04:00:00z";

            post['finished'] = [0, 1];

            Crud.post(typeRequest, post, 'api/searchOrdersDriver')
                .success(function (data) {
                })
                .error(function (data) {
                });
        }
        $scope.fakeReqy = function () {
            var post = {};
            var typeRequest = 'form-urlencoded';

            post['route'] = 'search';
            post['driver_phone'] = '0749313571';
            post['driver_token'] = 'HozwD4YLQP';//'kMi0oGL2fq';//'HozwD4YLQP';
            post['order_id'] = '962799';

            Crud.post(typeRequest, post, 'api/showOrder')
                .success(function (data) {
                })
                .error(function (data) {
                });
        }

        $scope.saveReason = function (keySlot, keyOrder, idOrder, idSlot, reason) {
            $scope.additionals['invalid'] = '';
            var post = {};
            post['order_id'] = idOrder;
            post['slot_id'] = idSlot;
            post['reason'] = reason;
            post['route'] = 'saveReason';
            var typeRequest = 'form-urlencoded';

            Crud.post(typeRequest, post, $scope.path + '/saveReason')
                    .success(function (data) {
                        $scope.errors = {};
                        if (!angular.isUndefined($scope.models)) {
                            $scope.models[keySlot].orders[keyOrder].reason_nondelivery = reason;
                        }
                        $scope.controlReason = [];
                    })
                    .error(function (data) {
                        $scope.errors = data.errors;
                    });
            $scope.errors = {};
        }

        /* update order status */
        $scope.updateOrderStatus = function (ev, modelId, orderId, statusOrder) {
            $scope.additionals['invalid'] = '';
            var post = {};
            post['id'] = modelId;
            post['order_id'] = orderId;
            post['order_status'] = statusOrder;
            post['route'] = 'updateOrderStatus';
            var typeRequest = 'form-urlencoded';

            Crud.post(typeRequest, post, $scope.path + '/updateOrderStatus')
                    .success(function (data) {
                        $scope.errors = {};
                        if (!angular.isUndefined(data.currentModel)) {
                            if (!angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, data.currentModel);
                            }
                        }
                    })
                    .error(function (data) {
                        $scope.errors = data.errors;
                    });
            $scope.errors = {};

        }

        /* update amount driver slot */
        $scope.updateAmountDriver = function (ev, modelId, value, prop) {
            $scope.additionals['invalid'] = '';
            if (ev.keyCode === 13) {

                var post = {};
                post['id'] = modelId;
                post[prop] = value;
                post['prop'] = prop;
                post['route'] = 'updateAmountDriver';
                var typeRequest = 'form-urlencoded';

                var confirm = $mdDialog.confirm()
                        .title('Confirma modificare ?')
                        .targetEvent(ev)
                        .ok('Da')
                        .cancel('Nu');
                $mdDialog.show(confirm).then(function () {
                    Crud.post(typeRequest, post, $scope.path + '/updateAmountDriver')
                            .success(function (data) {
                                $scope.errors = {};
                                if (!angular.isUndefined(data.currentModel)) {
                                    if (!angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, data.currentModel);
                                    }
                                }

                                 if (!angular.isUndefined($scope.notificationsAll[data['driver_id']])) {
                                        if(data['amount_driver_cash'] > 0){
                                                $scope.notificationsAll[data['driver_id']]['amount_driver_cash'] = data['amount_driver_cash'];
                                        } else {
                                                delete $scope.notificationsAll[data['driver_id']];
                                        }
                                }
                               $timeout($scope.additionals['openNotification'], 1000);

                            })
                            .error(function (data) {
                                $scope.errors = data.errors;
                            });

                }, function () {
                    post['cancel'] = 'yes';
                    Crud.post(typeRequest, post, $scope.path + '/updateAmountDriver')
                            .success(function (data) {
                                $scope.errors = {};
                                if (!angular.isUndefined(data.currentModel)) {
                                    if (!angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, data.currentModel);
                                    }
                                }

                                 if (!angular.isUndefined($scope.notificationsAll[data['driver_id']])) {
                                        if(data['amount_driver_cash'] > 0){
                                                $scope.notificationsAll[data['driver_id']]['amount_driver_cash'] = data['amount_driver_cash'];
                                        } else {
                                                delete $scope.notificationsAll[data['driver_id']];
                                        }
                                }
                               $timeout($scope.additionals['openNotification'], 1000);


                            })
                            .error(function (data) {
                                $scope.errors = data.errors;
                            });
                    $scope.errors = {};
                });
            }
        }

        if (angular.isUndefined($scope.notifications)) {
                $scope.notifications = {};
        }
        $scope.additionals['openNotification'] = function (driver_id) {

                /* add notifications */
                if (angular.isUndefined($scope.notifications)) {
                        $scope.notifications = {};
                }
                //console.log($scope.notificationsAll)
                //console.log($scope.notifications)

                //$scope.notificationsAll.forEach(function (item, key) {
               angular.forEach($scope.notifications, function(itemNot, keyNot){
                  if(angular.isUndefined($scope.notificationsAll[keyNot])){
                      delete($scope.notifications[keyNot]);
                  }
               });
               angular.forEach($scope.notificationsAll, function(item, key){
                //if(parseInt(item['amount_driver_cash']) >= parseInt($scope.additionals['max_amount_driver'])){
                        if(!angular.isUndefined($scope.notifications[key]) && $scope.notifications[key]['driver_name'] == item['driver_name'] && $scope.notifications[key]['amount_driver_cash'] != item['amount_driver_cash']){
                                        $scope.notifications[key] = {};
                                        $scope.notifications[key]['driver_name'] = item.driver_name;
                                        $scope.notifications[key]['amount_driver_cash'] = item['amount_driver_cash'];

                                       /* var audioElement = document.createElement('audio');
                                        audioElement.setAttribute('src', $scope.additionals['publicAudioPath'] + '/bell.mp3');
                                        audioElement.play();*/
                         } else {
                                if(!angular.isUndefined($scope.notifications[key]) && $scope.notifications[key]['driver_name'] == item['driver_name'] && !angular.isUndefined($scope.notifications[key]['close']) && $scope.notifications[key]['close'] == 1 ){
                                 } else {
                                        $scope.notifications[key] = {};
                                        $scope.notifications[key]['driver_name'] = item.driver_name;
                                        $scope.notifications[key]['amount_driver_cash'] = item['amount_driver_cash'];

                                        /*var audioElement = document.createElement('audio');
                                        audioElement.setAttribute('src', $scope.additionals['publicAudioPath'] + '/bell.mp3');
                                        audioElement.play();*/
                                }
                        }
                       /* } else {
                                delete($scope.notifications[key]);
                        }*/
                });

            // console.log( $scope.notifications)

                /* end add notifications */

             var controlClose = 0;
              angular.forEach($scope.notifications, function(item, key){
                        if(!angular.isUndefined(item['close']) && item['close'] == 1 && !angular.isUndefined($scope.notificationsAll[key]) && !angular.isUndefined(item['amount_driver_cash']) && parseInt($scope.notificationsAll[key]['amount_driver_cash']) == parseInt(item['amount_driver_cash'])){
                                controlClose = 1;
                        } else {
                                controlClose = 0;
                        }
              });

              if ($scope.notificationsAll != null && $scope.notificationsAll != 'null' && angular.isUndefined($scope.notificationsAll.length) && controlClose == 0) {
                        if (!angular.isUndefined(driver_id) && !angular.isUndefined($scope.notifications[driver_id])) {
                                $scope.additionals['openNotificationPopup'](driver_id);
                        }
               }

        }

         $scope.additionals['openNotificationPopup'] = function (driver_id) {

                var audioElement = document.createElement('audio');
                audioElement.setAttribute('src', $scope.additionals['publicAudioPath'] + '/bell.mp3');
                audioElement.play();

                $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'showNotificationsDialog.tmpl.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: false,
                            locals: {pathTemplate: $scope.pathTemplate, additionals: $scope.additionals, notificationsAll:$scope.notificationsAll, notifications: $scope.notifications}
                        });
                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals', 'notificationsAll', 'notifications'];

                        function DialogController($scope, $mdDialog, pathTemplate, additionals, notificationsAll, notifications) {
                            $scope.pathTemplate = pathTemplate;
                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };
                            $scope.additionals = additionals;
                            $scope.additionals['buttonDisabled'] = false;

                            //$scope.notificationsAll = notificationsAll;
                            //$scope.notifications = notifications;
                            $scope.notificationPopup = notifications[driver_id];

                            $scope.closeNotification = function (key) {
                                    //$scope.notifications.splice(key, 1);
                                    $scope.notifications[key]['close'] = 1;
                                }
                            }
        }
        $timeout($scope.additionals['openNotification'], 1000);
        $scope.closeNotification = function (key) {
            $scope.notifications.splice(key, 1);
        }

        /* collect slot */
        $scope.collectSlot = function (ev, path, model) {
            $scope.additionals['invalid'] = '';
            $scope.modelData = {};
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'collectSlotDialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {pathTemplate: $scope.pathTemplate, path: path, model: model, additionals: $scope.additionals, notificationsAll:$scope.notificationsAll}
            }).then(function (closeModel) {
                if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                    if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                            $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                        }
                        if (!angular.isUndefined($scope.modelData)) {
                            $scope.modelData = $scope.additionals['dataCurrentModel'];
                        }
                    } else {
                        /*if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                            $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                        }
                        if (!angular.isUndefined($scope.modelData)) {
                            $scope.modelData = currentModel;
                        }*/
                    }

                }
            });

            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'path', 'model', 'additionals', 'notificationsAll'];
            function DialogController($scope, $mdDialog, pathTemplate, path, model, additionals, notificationsAll) {
                $scope.pathTemplate = pathTemplate;
                $scope.cancel = function () {
                    $mdDialog.cancel();
                };
                $scope.path = path;
                $scope.additionals = additionals;
                $scope.modelData = model;

                /* collect model */
                $scope.collectModel = function () {
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.isLoading = true;
                    var typeRequest = 'form-urlencoded';
                    var post = {};
                    post['route'] = 'collectSlot';
                    post['id'] = model.id;
                    post['amount_driver_cash_collected'] = model.amount_driver_cash_collected;
                    Crud.post(typeRequest, post, $scope.path + '/collectSlot')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined(data.currentModel)) {
                                        $scope.additionals['dataCurrentModel'] = data.currentModel;
                                    }

                                   $scope.notificationsAll = notificationsAll;
                                   if (!angular.isUndefined($scope.notificationsAll[data['driver_id']])) {
                                                if(data['amount_driver_cash'] > 0){
                                                        $scope.notificationsAll[data['driver_id']]['amount_driver_cash'] = data['amount_driver_cash'];
                                                } else {
                                                        delete $scope.notificationsAll[data['driver_id']];
                                                }
                                        }
                                       $timeout($scope.additionals['openNotification'], 1000);

                                }
                                $scope.isLoading = false;
                                $mdDialog.hide();
                                $timeout($scope.additionals['openNotification'], 1000);
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.errors = data.errors;
                                $scope.isLoading = false;
                                $scope.additionals['buttonDisabled'] = false;
                            });
                };
            }
        };

        /* collect multiple slots */
        $scope.collectMultipleModel = function (ev, path) {

            $scope.additionals['invalid'] = '';
            $scope.modelData = {};
            if ($scope.checkSelected($scope.selected, ev) === true) {
                var currentModels = {};
                angular.forEach($scope.selected, function (items, index) {
                    currentModels[index] = {};
                    angular.forEach(items, function (item, key) {
                        if (key == 'id' || key == 'amount_driver_cash_collected') {
                            currentModels[index][key] = item;
                        }
                    });
                });

                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'collectMultipleDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        path: path,
                        models: currentModels,
                        additionals: $scope.additionals,
                        selected: $scope.selected,
                        selectedAll: $scope.selectedAll,
                        notificationsAll:$scope.notificationsAll

                    }
                }).then(function () {
                    if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                        angular.forEach(currentModels, function (items, index) {
                            if (!angular.isUndefined($scope.additionals['dataCurrentModels'])) {
                                $scope.getElement($scope.models, $scope.additionals['dataCurrentModels'][items['id']]);
                                currentModels[index] = $scope.additionals['dataCurrentModels'][items['id']];
                            } else {
                                $scope.getElement($scope.models, items);
                            }
                            items.selected = false;
                            delete($scope.selected[index]);
                        })
                        $scope.selectedAll = false;
                    }
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'path', 'models', 'additionals', 'selected', 'selectedAll', 'notificationsAll'];
                function DialogController($scope, $mdDialog, pathTemplate, path, models, additionals, selected, selectedAll, notificationsAll) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.modelsData = models;
                    $scope.additionals = additionals;
                    $scope.selected = selected;
                    $scope.selectedAll = selectedAll;
                    $scope.path = path;
                    $scope.notificationsAll = notificationsAll;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    /* collect slots */
                    $scope.collectMultipleSlot = function () {
                        $scope.additionals['buttonDisabled'] = true;
                        $scope.isLoading = true;
                        var typeRequest = 'form-urlencoded';
                        var post = models;
                        post['route'] = 'collectMultipleSlot';
                        Crud.post(typeRequest, post, $scope.path + '/collectMultipleSlot')
                                .success(function (data) {
                                    if (!angular.isUndefined(data.invalid)) {
                                        $scope.additionals['invalid'] = data.invalid;
                                    } else {
                                        if (!angular.isUndefined(data.currentModels)) {
                                            $scope.additionals['dataCurrentModels'] = data.currentModels;
                                        }

                                       if (!angular.isUndefined(data.modelsArrayDriversIds)) {
                                               angular.forEach(data.modelsArrayDriversIds, function(item, key){
                                                         if (!angular.isUndefined($scope.notificationsAll[item])) {
                                                               if (!angular.isUndefined(data.amount_driver_cash_array[item])) {
                                                                        if(data.amount_driver_cash_array[item]['amount_driver_cash'] > 0){
                                                                                $scope.notificationsAll[item]['amount_driver_cash'] = data.amount_driver_cash_array[item]['amount_driver_cash'];
                                                                        } else {
                                                                                delete $scope.notificationsAll[item];
                                                                        }
                                                                } else {
                                                                        delete $scope.notificationsAll[item];
                                                                }
                                                        }

                                                });
                                                 $timeout($scope.additionals['openNotification'], 1000);
                                        }


                                    }
                                    $scope.isLoading = false;
                                    $mdDialog.hide();
                                    $timeout($scope.additionals['openNotification'], 1000);
                                    $scope.additionals['buttonDisabled'] = false;
                                })
                                .error(function (data) {
                                    $scope.errors = data.errors;
                                    $scope.isLoading = false;
                                    $scope.additionals['buttonDisabled'] = false;
                                });
                    };
                }
            }
            //$scope.selectedAll = false;
        };

        /* collect multiple slots per driver */
        $scope.cancelCollectMultipleSlotDriver = function () {
            $scope.modelData.driver_id = '';
            $scope.modelData.sum = '';
        }

        $scope.additionals['getDriversWithAmounts'] = function (ev) {
            Crud.get($scope.path + '/getDriversWithAmounts')
                    .success(function (data) {
                        if (angular.isUndefined($scope.additionals['driversWithAmounts'])) {
                            $scope.additionals['driversWithAmounts'] = [];
                        }
                        $scope.additionals['driversWithAmounts'] = data.drivers;

                    });
        }

        $scope.additionals['selectDriverWithAmounts'] = function (ev, driver_id) {
            if (angular.isUndefined($scope.driverWithAmounts)) {
                $scope.driverWithAmounts = {};
            }
            var positionDriver = $scope.additionals['driversWithAmounts'].map(function (e) {
                return e['id'];
            }).indexOf(parseInt(driver_id));
            if (positionDriver >= 0) {
                $scope.driverWithAmounts['amount_driver_cash_collected'] = $scope.additionals['driversWithAmounts'][positionDriver]['amount_driver_cash_collected'];
                $scope.driverWithAmounts['amount_dispatcher_cash_collected'] = $scope.additionals['driversWithAmounts'][positionDriver]['amount_dispatcher_cash_collected'];
            } else {
                $scope.driverWithAmounts['amount_driver_cash_collected'] = 0;
                $scope.driverWithAmounts['amount_dispatcher_cash_collected'] = 0;
            }
        }

        $scope.collectMultipleSlotDriver = function (ev, path, model) {

            $scope.additionals['invalid'] = '';

            $scope.additionals['buttonDisabledcollectMultipleSlotDriver'] = true;
            $scope.isLoadingMultipleSlotDriver = true;
            var typeRequest = 'form-urlencoded';
            var post = model;
            post['route'] = 'collectMultipleSlotDriver';
            Crud.post(typeRequest, post, $scope.path + '/collectMultipleSlotDriver')
                    .success(function (data) {
                        $scope.modelData.sum = '';

                        if (!angular.isUndefined(data.invalid)) {
                            $scope.additionals['invalid'] = data.invalid;
                        } else {
                            if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {

                                if (angular.isUndefined($scope.driverWithAmounts)){
                                        $scope.driverWithAmounts = {};
                                }
                                $scope.driverWithAmounts.amount_dispatcher_cash_collected = data.amount_dispatcher_cash_collected;
                                if (data.currentModels instanceof Array) {
                                } else {
                                            angular.forEach($scope.models, function (items, index) {
                                                if (!angular.isUndefined(data.currentModels)) {
                                                    if (!angular.isUndefined(items['id'])) {
                                                        if (!angular.isUndefined(data.currentModels[items['id']])) {
                                                            $scope.getElement($scope.models, data.currentModels[items['id']]);

                                                            $scope.models[index] = data.currentModels[items['id']];
                                                        }
                                                    }
                                                } else {
                                                    $scope.getElement($scope.models, items);
                                                }
                                            })
                                    }

                                if (!angular.isUndefined($scope.notificationsAll[data['driver_id']])) {
                                        if(data['amount_driver_cash'] > 0){
                                                $scope.notificationsAll[data['driver_id']]['amount_driver_cash'] = data['amount_driver_cash'];
                                        } else {
                                                delete $scope.notificationsAll[data['driver_id']];
                                        }
                                }
                               $timeout($scope.additionals['openNotification'], 1000);


                            }
                        }
                        $scope.isLoadingMultipleSlotDriver = false;
                        //$timeout($scope.additionals['openNotification'], 2000);
                        $scope.additionals['buttonDisabledcollectMultipleSlotDriver'] = false;
                        $scope.errors = {};
                    })
                    .error(function (data) {
                        $scope.errors = data.errors;
                        $scope.isLoadingMultipleSlotDriver = false;
                        $scope.additionals['buttonDisabledcollectMultipleSlotDriver'] = false;
                    });

        };

        /* close slot */
        $scope.closeSlot = function (ev, path, model) {
            $scope.additionals['invalid'] = '';
            $scope.modelData = {};
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'closeSlotDialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {pathTemplate: $scope.pathTemplate, path: path, model: model, additionals: $scope.additionals}
            }).then(function (closeModel) {
                if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                    if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                            $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                        }
                        if (!angular.isUndefined($scope.modelData)) {
                            $scope.modelData = $scope.additionals['dataCurrentModel'];
                        }
                    } else {
                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                            $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                        }
                        if (!angular.isUndefined($scope.modelData)) {
                            $scope.modelData = currentModel;
                        }
                    }

                }
            });

            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'path', 'model', 'additionals'];
            function DialogController($scope, $mdDialog, pathTemplate, path, model, additionals) {
                $scope.pathTemplate = pathTemplate;
                $scope.cancel = function () {
                    $mdDialog.cancel();
                };
                $scope.path = path;
                $scope.additionals = additionals;
                $scope.modelData = model;

                /* close model */
                $scope.closeModel = function () {
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.isLoading = true;
                    var typeRequest = 'form-urlencoded';
                    var post = {};
                    post['route'] = 'closeSlot';
                    post['id'] = model.id;
                    post['amount_driver_cash_required'] = model.amount_driver_cash_required;
                    post['amount_dispatcher_cash_collected'] = model.amount_dispatcher_cash_collected;
                    Crud.post(typeRequest, post, $scope.path + '/closeSlot')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined(data.currentModel)) {
                                        $scope.additionals['dataCurrentModel'] = data.currentModel;
                                    }
                                }
                                $scope.isLoading = false;
                                $mdDialog.hide();
                                $timeout($scope.additionals['openNotification'], 1000);
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.errors = data.errors;
                                $scope.isLoading = false;
                                $scope.additionals['buttonDisabled'] = false;
                            });
                };
            }
        };

        /* show order on slot */
        $scope.controlShowOrder = [];
        $scope.classOrder = [];
        $scope.showOrder = function (orderId, orderNo) {
            $scope.orderId = orderId;
            $scope.orderNo = orderNo;

            $scope.classOrder = [];
            $scope.classOrder[orderId] = 'class-order';

            $scope.controlShowOrder = [];
            $scope.controlShowOrder[orderId] = true;

            var heightMap = $('.app-map-center').height();
            if (!angular.isUndefined(heightMap)) {
                heightMap = heightMap + 125;
            } else {
                heightMap = 95;
            }
            angular.element(document.querySelector('.showOrder')).css('top', heightMap);

            Crud.get($scope.path + '/showOrder?order_id=' + orderId)
                    .success(function (data) {
                        $scope.modelDataOrder = data;
                        $scope.additionals['calcProcess'](data, 'Order');
                    });

        }
        $scope.closeShowOrder = function (orderId) {
            $scope.orderId = orderId;
            $scope.controlShowOrder[orderId] = false;
            $scope.classOrder = [];
        }
        /* end show order on slot */

        /* change order in slot */
        $scope.getOrdersChangeSlot = function (slotId) {
            Crud.get($scope.path + '/getOrdersChangeSlot?slotId=' + slotId)
                    .success(function (data) {
                        $scope.additionals['ordersAllChangeSlot'] = data.orders;
                    });
        }

        $scope.getSlotsCurrent = function (slotId) {
            Crud.get($scope.path + '/getSlotsCurrent?slotId=' + slotId)
                    .success(function (data) {
                        $scope.additionals['slotsCurrent'] = data;
                    });
        }

        $scope.additionals['searchTermSlot'];
        $scope.additionals['clearSearchTermSlot'] = function () {
            $scope.additionals['searchTermSlot'] = '';
        };
        $scope.additionals['onSearchChangeSlot'] = function (ev) {
            ev.stopPropagation();
        };

        $scope.changeSlot = function (ev, path, model) {

            $scope.actionLabel = 'Mutare comanda in alt slot';

            $scope.modelData['orders'] = [];
            $scope.modelData['order_ids'] = [];

            if ($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'changeslot';
                $scope.errors = {};

                if ($location.path() == '/slot') {
                    var positionAction = $('.class-action').position();
                    angular.element(document.querySelector('.fill-height')).animate({scrollTop: positionAction.top}, "slow");
                } else {
                    angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, "slow");
                }

                $scope.slot_no = model.slot_no;
                $scope.getOrdersChangeSlot(model.id);
                $scope.getSlotsCurrent(model.id);

                $scope.additionals['invalid'] = '';
                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };

                $scope.changeSlotModel = function () {
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.isLoading = true;

                    var typeRequest = 'form-urlencoded';
                    var post = {};
                    post['route'] = 'changeSlot';
                    post['current_slot_id'] = model.id;
                    post['order_ids'] = $scope.modelData.order_ids;
                    post['new_slot_id'] = $scope.modelData.new_slot_id;
                    Crud.post(typeRequest, post, $scope.path + '/changeSlot')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined(data.currentModel)) {
                                        if (!angular.isUndefined($scope.models)) {
                                            $scope.getElement($scope.models, data.currentModel);
                                        }
                                    }
                                    if (!angular.isUndefined(data.newModel)) {
                                        if (!angular.isUndefined($scope.models)) {
                                            $scope.getElement($scope.models, data.newModel);
                                        }
                                    }
                                }
                                $scope.modelData = {};
                                $scope.errors = {};
                                $scope.isLoading = false;
                                $scope.controlSH = false;
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                            });
                };
            }
            if ($scope.mode_action == 'dialog') {

                $scope.additionals['invalid'] = '';
                $scope.errors = {};
                $scope.action = 'changeslot';

                $scope.slot_no = model.slot_no;
                $scope.current_slot_id = model.id;
                $scope.path = path;
                $scope.getOrdersChangeSlot(model.id);
                $scope.getSlotsCurrent(model.id);

                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'changeSlotDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        model: $scope.modelData,
                        additionals: $scope.additionals,
                        action: $scope.action,
                        slot_no: $scope.slot_no,
                        current_slot_id: $scope.current_slot_id,
                        path: $scope.path
                    }
                }).then(function () {
                    if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                        if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                            if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                            }
                        }
                        if (!angular.isUndefined($scope.additionals['dataNewModel'])) {
                            if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, $scope.additionals['dataNewModel']);
                            }
                        }
                    }
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'additionals', 'action', 'slot_no', 'current_slot_id', 'path'];
                function DialogController($scope, $mdDialog, pathTemplate, model, additionals, action, slot_no, current_slot_id, path) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.modelData = model;
                    $scope.additionals = additionals;
                    $scope.action = action;
                    $scope.slot_no = slot_no;
                    $scope.current_slot_id = current_slot_id;
                    $scope.path = path;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    $scope.changeSlotModel = function () {
                        $scope.additionals['buttonDisabled'] = true;
                        $scope.isLoading = true;

                        var typeRequest = 'form-urlencoded';
                        var post = {};
                        post['route'] = 'changeSlot';
                        post['current_slot_id'] = $scope.current_slot_id;
                        post['order_ids'] = $scope.modelData.order_ids;
                        post['new_slot_id'] = $scope.modelData.new_slot_id;
                        Crud.post(typeRequest, post, $scope.path + '/changeSlot')
                                .success(function (data) {
                                    if (!angular.isUndefined(data.invalid)) {
                                        $scope.additionals['invalid'] = data.invalid;
                                    } else {
                                        if (!angular.isUndefined(data.currentModel)) {
                                            $scope.additionals['dataCurrentModel'] = data.currentModel;
                                        }
                                        if (!angular.isUndefined(data.currentModel)) {
                                            $scope.additionals['dataNewModel'] = data.newModel;
                                        }

                                    }
                                    $scope.isLoading = false;
                                    $mdDialog.hide();
                                    $scope.additionals['buttonDisabled'] = false;
                                    $scope.modelData = {};
                                    $scope.slot_no = 0;
                                    $scope.current_slot_id = 0;
                                })
                                .error(function (data) {
                                    $scope.isLoading = false;
                                    $scope.errors = data.errors;
                                    $scope.additionals['buttonDisabled'] = false;
                                });
                    };

                }
            }
        };
        /* end change order in slot */

        /* reports */
        if ($rootScope.settings.enable_packaging == 1) {
            $scope.nonDisplay = 0;
        } else {
            $scope.nonDisplay = 1;
        }
        $scope.printReport = $window;
        $scope.isLoadingPrinter = false;
        $scope.printPreview = function (ev, path, availableColumns, columns) {

            $scope.isLoadingPrinter = true;
            var popup = $scope.printReport.open('', '_blank', 'width=800,height=300,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no,top=50');
            popup.document.open();

            Crud.search($scope.search, path, 1, 'p')
              .success(function (data) {
                  $scope.isLoadingPagination = false;
                  $scope.isLoadingPrinter = false;

                  $scope.additionals['buttonDisabledPagination'] = false;
                  var printColumns = {};
                  if (!angular.isUndefined(availableColumns) && availableColumns.length > 0) {
                      angular.forEach(columns, function (item, index) {
                          if (availableColumns.indexOf(index) >= 0) {
                              printColumns[index] = item;
                          }
                      });
                  } else {
                      printColumns = columns;
                  }
                  var title = 'Raport ';
                  if ($scope.search['reportType'] == 'reportDetail' || $scope.search['reportType'] == 'reportDetailDriver') {
                      title = title + 'detaliat';
                  }
                  if ($scope.search['reportType'] == 'reportDaily' || $scope.search['reportType'] == 'reportDailyDriver') {
                      title = title + 'zilnic';
                  }
                  if ($scope.search['reportType'] == 'reportMonthly' || $scope.search['reportType'] == 'reportMonthlyDriver') {
                      title = title + 'lunar';
                  }
                  if ($scope.search['reportType'] == 'reportDailyDriverTime') {
                      title = title + 'zilnic timp de livrare sofer';
                  }
                  if ($scope.search['reportType'] == 'reportDriverTime') {
                      title = title + 'timp de livrare sofer';
                  }
                  if ($scope.search['reportType'] == 'reportTip') {
                      title = title + 'tips';
                  }
                  if ($scope.search['reportType'] == 'reportActivity') {
                      title = title + 'activitate soferi';
                  }
                  title = title + '  ';
                  if ($scope.search['dateFrom']) {
                      title = title + moment($scope.search['dateFrom']).format('DD/MM/YY');
                  }
                  if ($scope.search['timeFrom']) {
                      title = title + moment($scope.search['timeFrom']).format(' HH:mm:ss');
                  }
                  if ($scope.search['dateFrom'] || $scope.search['timeFrom']) {
                      title = title + '   ';
                  }
                  if ($scope.search['dateTo']) {
                      title = title + moment($scope.search['dateTo']).format('DD/MM/YY');
                  }
                  if ($scope.search['timeTo']) {
                      title = title + moment($scope.search['timeTo']).format(' HH:mm:ss');
                  }

                  var html = '<div class="report-print">';
                  var orders = data.data;
                  if (orders.length > 0) {
                      html = html + '<table><tr>';
                      html = html + '<th>Nr.</th>';
                      angular.forEach(printColumns, function (itemColumn, keyColumn) {
                          if (!itemColumn['nonDisplay']) {
                              html = html + '<th>' + itemColumn['label'] + '</th>';
                          }
                      });
                      html = html + '</tr>';

                      var total_cash = 0;
                      var total_card = 0;
                      var total_online = 0;
                      var total_bonsv = 0;
                      var total_bank_transfer = 0;
                      var total_driver = 0;
                      var amount_driver_cash_required = 0;
                      var amount_dispatcher_cash_collected = 0;
                      var amount_dispatcher_card_collected = 0;
                      var total_amount_driver_cash_required = 0;
                      var total_amount_driver = 0;
                      var total_amount_dispatcher_card_collected = 0;
                      var total_amount_dispatcher_cash_collected = 0;
                      var total = 0;
                      var slots_nos = 0;
                      var orders_nos = 0;
                      var driver_cash_over = 0;
                      var total_cash_collected = 0;
                      var total_card_collected = 0;
                      var total_bonsv_collected = 0;
                      var total_bank_transfer_collected = 0;
                      var total_tips = 0;
                      var total_tips_driver = 0;
                      var total_tips_tax = 0;
                      var average_delivery_time = 0;
                      var order_nos_exceeded = 0;
                      var total_time = 0;
                      var active_time = 0;
                      var disconnected_time = 0;
                      var inactive_time = 0;

                      angular.forEach(orders, function (item, key) {
                          html = html + '<tr>';
                          var keys = key + 1;
                          html = html + '<td>' + keys + '</td>';
                          angular.forEach(printColumns, function (itemColumn, keyColumn) {
                              if(keyColumn == 'driver_cash_over'){
                                 item[keyColumn] = $scope.additionals['formatDecimal'](item[keyColumn]);
                              }
                              if (keyColumn == 'percent_nos_estimated_time_exceeded') {
                                item[keyColumn] = parseInt(item['order_nos_exceeded'] * 100/ item['orders_nos']);
                              }
                              if (!itemColumn['nonDisplay']) {
                                  if (itemColumn['filterType'] == 'select') {
                                      if (!angular.isUndefined(item[keyColumn])) {
                                          html = html + '<td>' + $scope.additionals['associativeColumn'](printColumns[keyColumn], item[keyColumn]) + '</td>';
                                      } else {
                                          html = html + '<td></td>';
                                      }
                                  } else {
                                      if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] != '') {
                                          if (keyColumn == 'orders') {
                                              html = html + '<td class="align-left">';
                                              var ordersInfos = '';
                                              angular.forEach(item['orders'], function (itemOrder, keyOrder) {
                                                  var keyOrders = keyOrder + 1;
                                                  ordersInfos = ordersInfos + keyOrders + '.' + itemOrder['order_no'] + ':' + itemOrder['street_name'];
                                                  if (itemOrder['address_no']) {
                                                      ordersInfos = ordersInfos + ', nr.' + itemOrder['address_no'];
                                                  }
                                                  if (itemOrder['address_section']) {
                                                      ordersInfos = ordersInfos + ', sc.' + itemOrder['address_section'];
                                                  }
                                                  if (itemOrder['address_block']) {
                                                      ordersInfos = ordersInfos + ', bl.' + itemOrder['address_block'];
                                                  }
                                                  if (itemOrder['address_level']) {
                                                      ordersInfos = ordersInfos + ', et.' + itemOrder['address_level'];
                                                  }
                                                  if (itemOrder['address_flat']) {
                                                      ordersInfos = ordersInfos + ', ap.' + itemOrder['address_flat'];
                                                  }
                                                  if (itemOrder['section_name']) {
                                                      ordersInfos = ordersInfos + ', ' + itemOrder['section_name'];
                                                  }
                                                  if (itemOrder['locality_name']) {
                                                      ordersInfos = ordersInfos + ', ' + itemOrder['locality_name'];
                                                  }
                                                  ordersInfos = ordersInfos + '<br><br>';

                                              });
                                              html = html + ordersInfos + '</td>';
                                          }
                                          /*else if(keyColumn == 'slot_status') {
                                           if($scope.search['reportType'] == 'reportDetail') {
                                           html = html + '<td>';
                                           if() {

                                           }
                                           html = html + ordersPay;
                                           html = html + '<b>'+$scope.additionals['formatDecimal'](totalOrdersPay) + '</b></td>';
                                           } else {
                                           html = html + '<td>' + item[keyColumn] + '</td>';
                                           }
                                           }*/
                                           else if (keyColumn == 'total_cash') {
                                              if ($scope.search['reportType'] == 'reportDetail' || $scope.search['reportType'] == 'reportDetailDriver') {
                                                  html = html + '<td>';
                                                  var ordersPay = '';
                                                  var totalOrdersPay = 0;
                                                  angular.forEach(item['orders'], function (itemOrder, keyOrder) {
                                                      ordersPay = ordersPay + $scope.additionals['formatDecimal'](itemOrder['payment_cash']);
                                                      ordersPay = '\n' + ordersPay + '<br><br>';
                                                      totalOrdersPay = totalOrdersPay + parseFloat(itemOrder['payment_cash'])
                                                  });
                                                  html = html + ordersPay;
                                                  html = html + '<b>' + $scope.additionals['formatDecimal'](totalOrdersPay) + '</b></td>';
                                              } else {
                                                  html = html + '<td>' + item[keyColumn] + '</td>';
                                              }
                                          } else if (keyColumn == 'total_card') {
                                              if ($scope.search['reportType'] == 'reportDetail' || $scope.search['reportType'] == 'reportDetailDriver') {
                                                  html = html + '<td>';
                                                  var ordersPay = '';
                                                  var totalOrdersPay = 0;
                                                  angular.forEach(item['orders'], function (itemOrder, keyOrder) {
                                                      ordersPay = '\n' + ordersPay + $scope.additionals['formatDecimal'](itemOrder['payment_card']);
                                                      ordersPay = ordersPay + '<br><br>';
                                                      totalOrdersPay = totalOrdersPay + parseFloat(itemOrder['payment_card'])
                                                  });
                                                  html = html + ordersPay;
                                                  html = html + '<b>' + $scope.additionals['formatDecimal'](totalOrdersPay) + '</b></td>';
                                              } else {
                                                  html = html + '<td>' + item[keyColumn] + '</td>';
                                              }
                                          } else if (keyColumn == 'total_online') {
                                              if ($scope.search['reportType'] == 'reportDetail' || $scope.search['reportType'] == 'reportDetailDriver') {
                                                  html = html + '<td>';
                                                  var ordersPay = '';
                                                  var totalOrdersPay = 0;
                                                  angular.forEach(item['orders'], function (itemOrder, keyOrder) {
                                                      ordersPay = ordersPay + $scope.additionals['formatDecimal'](itemOrder['payment_online']);
                                                      ordersPay = '\n' + ordersPay + '<br><br>';
                                                      totalOrdersPay = totalOrdersPay + parseFloat(itemOrder['payment_online'])
                                                  });
                                                  html = html + ordersPay;
                                                  html = html + '<b>' + $scope.additionals['formatDecimal'](totalOrdersPay) + '</b></td>';
                                              } else {
                                                  html = html + '<td>' + item[keyColumn] + '</td>';
                                              }
                                          } else if (keyColumn == 'total_bonsv') {
                                              if ($scope.search['reportType'] == 'reportDetail' || $scope.search['reportType'] == 'reportDetailDriver') {
                                                  html = html + '<td>';
                                                  var ordersPay = '';
                                                  var totalOrdersPay = 0;
                                                  angular.forEach(item['orders'], function (itemOrder, keyOrder) {
                                                      ordersPay = ordersPay + $scope.additionals['formatDecimal'](itemOrder['payment_bonsv']);
                                                      ordersPay = '\n' + ordersPay + '<br><br>';
                                                      totalOrdersPay = totalOrdersPay + parseFloat(itemOrder['payment_bonsv'])
                                                  });
                                                  html = html + ordersPay;
                                                  html = html + '<b>' + $scope.additionals['formatDecimal'](totalOrdersPay) + '</b></td>';
                                              } else {
                                                  html = html + '<td>' + item[keyColumn] + '</td>';
                                              }

                                        } else if (keyColumn == 'total_bank_transfer') {
                                            if ($scope.search['reportType'] == 'reportDetail' || $scope.search['reportType'] == 'reportDetailDriver') {
                                                html = html + '<td>';
                                                var ordersPay = '';
                                                var totalOrdersPay = 0;
                                                angular.forEach(item['orders'], function (itemOrder, keyOrder) {
                                                    ordersPay = ordersPay + $scope.additionals['formatDecimal'](itemOrder['payment_bank_transfer']);
                                                    ordersPay = '\n' + ordersPay + '<br><br>';
                                                    totalOrdersPay = totalOrdersPay + parseFloat(itemOrder['payment_bank_transfer'])
                                                });
                                                html = html + ordersPay;
                                                html = html + '<b>' + $scope.additionals['formatDecimal'](totalOrdersPay) + '</b></td>';
                                            } else {
                                                html = html + '<td>' + item[keyColumn] + '</td>';
                                            }

                                          } else if (keyColumn == 'average_delivery_time') {
                                            html = html + '<td>' + $scope.additionals['formatTime'](item[keyColumn]) + '</td>';

                                          } else if (keyColumn == 'total_time' || keyColumn == 'active_time' || keyColumn == 'disconnected_time' || keyColumn == 'inactive_time') {
                                            html = html + '<td>' + $scope.additionals['formatTime'](item[keyColumn]) + '</td>';
                                          } else {
                                              html = html + '<td>' + item[keyColumn] + '</td>';
                                          }
                                      } else {
                                          html = html + '<td></td>';
                                      }
                                  }
                              }
                          });
                          html = html + '</tr>';

                          total_cash = total_cash + parseFloat(item['total_cash']);
                          total_card = total_card + parseFloat(item['total_card']);
                          total_online = total_online + parseFloat(item['total_online']);
                          total_bonsv = total_bonsv + parseFloat(item['total_bonsv']);
                          total_bank_transfer = total_bank_transfer + parseFloat(item['total_bank_transfer']);
                          total_driver = total_driver + parseFloat(item['total_driver']);
                          amount_driver_cash_required = amount_driver_cash_required + parseFloat(item['amount_driver_cash_required']);
                          amount_dispatcher_cash_collected = amount_dispatcher_cash_collected + parseFloat(item['amount_dispatcher_cash_collected']);
                          amount_dispatcher_card_collected = amount_dispatcher_card_collected + parseFloat(item['amount_dispatcher_card_collected']);
                          total_amount_driver_cash_required = total_amount_driver_cash_required + parseFloat(item['total_amount_driver_cash_required']);
                          total_amount_dispatcher_cash_collected = total_amount_dispatcher_cash_collected + parseFloat(item['total_amount_dispatcher_cash_collected']);
                          total_amount_dispatcher_card_collected = total_amount_dispatcher_card_collected + parseFloat(item['total_amount_dispatcher_card_collected']);
                          total = total + parseFloat(item['total']);
                          slots_nos = slots_nos + parseInt(item['slots_nos']);
                          orders_nos = orders_nos + parseInt(item['orders_nos']);
                          driver_cash_over = driver_cash_over + parseFloat(item['driver_cash_over']);

                          total_cash_collected = total_cash_collected + parseFloat(item['total_cash_collected']);
                          total_card_collected = total_card_collected + parseFloat(item['total_card_collected']);
                          total_bonsv_collected = total_bonsv_collected + parseFloat(item['total_bonsv_collected']);
                          total_bank_transfer_collected = total_bank_transfer_collected + parseFloat(item['total_bank_transfer_collected']);

                          total_tips = total_tips + parseFloat(item['total_tips']);
                          total_tips_driver = total_tips_driver + parseFloat(item['total_tips_driver']);
                          total_tips_tax = total_tips_tax + parseFloat(item['total_tips_tax']);

                          average_delivery_time = average_delivery_time + parseFloat(item['average_delivery_time']);
                          order_nos_exceeded = order_nos_exceeded + parseFloat(item['order_nos_exceeded']);

                          total_time = total_time + parseFloat(item['total_time']);
                          active_time = active_time + parseFloat(item['active_time']);
                          disconnected_time = disconnected_time + parseFloat(item['disconnected_time']);
                          inactive_time = inactive_time + parseFloat(item['inactive_time']);

                      });

                      html = html + '<tr>';
                      html = html + '<td>Total</td>';
                      angular.forEach(printColumns, function (itemColumn, keyColumn) {
                          if (!itemColumn['nonDisplay']) {
                              if (keyColumn == 'total_cash') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_cash) + '</td>';
                              } else if (keyColumn == 'total_card') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_card) + '</td>';
                              } else if (keyColumn == 'total_online') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_online) + '</td>';
                              } else if (keyColumn == 'total_bonsv') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_bonsv) + '</td>';
                              } else if (keyColumn == 'total_bank_transfer') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_bank_transfer) + '</td>';
                              } else if (keyColumn == 'total_driver') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_driver) + '</td>';
                              } else if (keyColumn == 'amount_driver_cash_required') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](amount_driver_cash_required) + '</td>';
                              } else if (keyColumn == 'amount_dispatcher_cash_collected') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](amount_dispatcher_cash_collected) + '</td>';
                              } else if (keyColumn == 'amount_dispatcher_card_collected') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](amount_dispatcher_card_collected) + '</td>';
                              } else if (keyColumn == 'total_amount_dispatcher_cash_collected') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_amount_dispatcher_cash_collected) + '</td>';
                              } else if (keyColumn == 'total_amount_dispatcher_card_collected') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_amount_dispatcher_card_collected) + '</td>';
                              } else if (keyColumn == 'slots_nos') {
                                  html = html + '<td class="align-right total">' + slots_nos + '</td>';
                              } else if (keyColumn == 'orders_nos') {
                                  html = html + '<td class="align-right total">' + orders_nos + '</td>';
                              } else if (keyColumn == 'total_amount_driver_cash_required') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_amount_driver_cash_required) + '</td>';
                              } else if (keyColumn == 'total_amount_dispatcher_cash_collected') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_amount_driver) + '</td>';
                              } else if (keyColumn == 'total_amount_dispatcher_card_collected') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_amount_dispatcher_card_collected) + '</td>';
                              } else if (keyColumn == 'total') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total) + '</td>';
                              } else if (keyColumn == 'driver_cash_over') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](driver_cash_over) + '</td>';
                              } else if (keyColumn == 'total_cash_collected') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_cash_collected) + '</td>';
                              } else if (keyColumn == 'total_card_collected') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_card_collected) + '</td>';
                              } else if (keyColumn == 'total_bonsv_collected') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_bonsv_collected) + '</td>';
                              } else if (keyColumn == 'total_bank_transfer_collected') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_bank_transfer_collected) + '</td>';
                              } else if (keyColumn == 'total_tips') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_tips) + '</td>';
                              } else if (keyColumn == 'total_tips_driver') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_tips_driver) + '</td>';
                              } else if (keyColumn == 'total_tips_tax') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_tips_tax) + '</td>';
                              } else if (keyColumn == 'average_delivery_time') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatTime'](average_delivery_time/orders.length) + '</td>';
                              } else if (keyColumn == 'total_time') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatTime'](total_time) + '</td>';
                              } else if (keyColumn == 'active_time') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatTime'](active_time) + '</td>';
                              } else if (keyColumn == 'disconnected_time') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatTime'](disconnected_time) + '</td>';
                              } else if (keyColumn == 'inactive_time') {
                                  html = html + '<td class="align-right total">' + $scope.additionals['formatTime'](inactive_time) + '</td>';
                              } else if (keyColumn == 'order_nos_exceeded') {
                                  html = html + '<td class="align-right total">' + order_nos_exceeded + '</td>';
                              } else {
                                  html = html + '<td></td>';
                              }
                          }

                      });
                      html = html + '</tr>';

                      html = html + '</table>';
                  }

                  popup.document.write('<!DOCTYPE html><html><head><title>' + title + '</title>'
                          + '<link rel="stylesheet" type="text/css" href="/css/print-preview.css" />'
                          + '</head><body onload="window.print(); window.close();">'
                          + html
                          + '</body></html>');
                  //popup.document.close();

              }).error(function (data) {
              $scope.isLoadingPagination = false;
              $scope.errors = data.errors;
            });

        }

        if ($location.path() == $scope.path + '/reportDetail') {
            $scope.columns = {
                'slot_no': {'label': 'Nr. slot', 'filter': 1, 'filterType': 'input'},
                'orders': {'label': 'Comenzi', 'filter': 2, 'filterType': 'input'},
                //'orders':{'label':'Comenzi', 'filter':0, 'filterType':'input'},
                'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                'created_at': {'label': 'Data', 'filter': 1, 'filterType': 'input'},

                //'total_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_cash': {'label': 'Cash de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_card': {'label': 'Card de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_online': {'label': 'Online (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bonsv': {'label': 'Bonuri de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bank_transfer': {'label': 'Transfer bancar (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                'total_driver': {'label': 'Total cash sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'amount_driver_cash_required': {'label': 'Total de incasat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'amount_dispatcher_cash_collected': {'label': 'Suma incasata cash dispecer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                //'amount_dispatcher_card_collected':{'label':'Suma incasata card dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'slot_status': {'label': 'Slot status', 'filter': 1, 'filterType': 'select'}
            };
            $scope.columns.slot_status.options = [
                {'id': '', 'value': ''},
                {'id': 1, 'value': 'inchis'},
                {'id': 0, 'value': 'deschis'}
            ];
            $scope.search['reportType'] = 'reportDetail';
            $scope.additionals['reportType'] = 'reportDetail';
            $scope.title = 'Dispecerat / Raport detaliat';
            $scope.classAction = 'td-small';
        }

        if ($location.path() == $scope.path + '/reportDaily') {
            $scope.columns = {
                'date': {'label': 'Data', 'filter': 1, 'filterType': 'input'},
                'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                'slots_nos': {'label': 'Nr. sloturi', 'filter': 1, 'filterType': 'input'},
                'orders_nos': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},

                //'total_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_cash': {'label': 'Cash de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_card': {'label': 'Card de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_online': {'label': 'Online (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bonsv': {'label': 'Bonuri de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bank_transfer': {'label': 'Transfer bancar (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                'total_driver': {'label': 'Total cash sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_amount_driver_cash_required': {'label': 'Total cash de incasat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_amount_dispatcher_cash_collected': {'label': 'Suma incasata cash dispecer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                //'total_amount_dispatcher_card_collected':{'label':'Suma incasata card dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
            };
            $scope.search['reportType'] = 'reportDaily';
            $scope.additionals['reportType'] = 'reportDaily';
            $scope.title = 'Dispecerat / Raport zilnic';
        }

        if ($location.path() == $scope.path + '/reportMonthly') {
            $scope.columns = {
                'month': {'label': 'Luna', 'filter': 1, 'filterType': 'input'},
                'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                'slots_nos': {'label': 'Nr. sloturi', 'filter': 1, 'filterType': 'input'},
                'orders_nos': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},

                //'total_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_cash': {'label': 'Cash de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_card': {'label': 'Card de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_online': {'label': 'Online (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bonsv': {'label': 'Bonuri de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bank_transfer': {'label': 'Transfer bancar (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                'total_driver': {'label': 'Total cash sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_amount_driver_cash_required': {'label': 'Total cash de incasat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_amount_dispatcher_cash_collected': {'label': 'Suma incasata cash dispecer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                //'total_amount_dispatcher_card_collected':{'label':'Suma incasata card dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
            };
            $scope.search['reportType'] = 'reportMonthly';
            $scope.additionals['reportType'] = 'reportMonthly';
            $scope.title = 'Dispecerat / Raport lunar';
            $scope.classAction = 'td-small';
        }

        $scope.changeColumns = function (reportTypeGeneral) {
            $scope.classAction = 'td-small';
            if (reportTypeGeneral == 'driver') {
                $scope.columns = {
                    'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                    'slots_nos': {'label': 'Nr. sloturi', 'filter': 1, 'filterType': 'input'},
                    'orders_nos': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                    /*'total_partial': {
                     'label': 'Plata partiala (' + $rootScope.currency + ')',
                     'filter': 1,
                     'filterType': 'input'
                     },*/
                    'total_cash': {'label': 'Cash de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_card': {'label': 'Card de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_online': {'label': 'Online (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_bonsv': {'label': 'Bonuri de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_bank_transfer': {'label': 'Transfer bancar (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                    'total_driver': {
                        'label': 'Total cash sofer (' + $rootScope.currency + ')',
                        'filter': 1,
                        'filterType': 'input'
                    },
                    'total_amount_driver_cash_required': {'label': 'Total de incasat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_amount_dispatcher_cash_collected': {'label': 'Suma incasata cash dispecer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    //'total_amount_dispatcher_card_collected':{'label':'Suma incasata card dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                    'total': {
                        'label': 'Total sloturi (' + $rootScope.currency + ')',
                        'filter': 1,
                        'filterType': 'input'
                    }
                };
            }
            if (reportTypeGeneral == 'day') {
                $scope.columns = {
                    'date': {'label': 'Data', 'filter': 1, 'filterType': 'input'},
                    'slots_nos': {'label': 'Nr. sloturi', 'filter': 1, 'filterType': 'input'},
                    'orders_nos': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                    /*'total_partial': {
                     'label': 'Plata partiala (' + $rootScope.currency + ')',
                     'filter': 1,
                     'filterType': 'input'
                     },*/
                    'total_cash': {'label': 'Cash de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_card': {'label': 'Card de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_online': {'label': 'Online (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_bonsv': {'label': 'Bonuri de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_bank_transfer': {'label': 'Transfer bancar (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                    'total_driver': {
                        'label': 'Total cash sofer (' + $rootScope.currency + ')',
                        'filter': 1,
                        'filterType': 'input'
                    },
                    'total_amount_driver_cash_required': {'label': 'Total de incasat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_amount_dispatcher_cash_collected': {'label': 'Suma incasata cash dispecer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    //'total_amount_dispatcher_card_collected':{'label':'Suma incasata card dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                    'total': {
                        'label': 'Total sloturi (' + $rootScope.currency + ')',
                        'filter': 1,
                        'filter': 1,
                        'filter': 1,
                        'filterType': 'input'
                    }
                };
            }
        }

        $scope.changeColumnsTip = function (reportTypeTip) {
            $scope.classAction = 'td-small';
            if (reportTypeTip == 'driver') {
                $scope.columns = {
                    'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                    'total_tips': {'label': 'Total tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_tips_driver': {'label': 'Total tips sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_tips_tax': {'label': 'Impozit tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
                };
            }
            if (reportTypeTip == 'day') {
                $scope.columns = {
                    'date': {'label': 'Data', 'filter': 1, 'filterType': 'input'},
                    'total_tips': {'label': 'Total tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_tips_driver': {'label': 'Total tips sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_tips_tax': {'label': 'Impozit tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
                };
            }
        }

        if ($location.path() == $scope.path + '/reportTip') {
            $scope.search.reportTypeTip = 'driver';
            if (angular.isUndefined($scope.search.reportTypeTip)) {
                $scope.search.reportTypeTip = 'driver';
            }
            $scope.additionals.reportTypeTip = $scope.search.reportTypeTip;
            $scope.searchModel = function (ev, path) {
                $scope.searchControl = true;
                $scope.last = 0;
                $scope.firstTime = 1;
                $scope.firstLoad = 0;
                $scope.getPaginateModel(path, 1, $scope.defaultItem);
                $scope.changeColumnsTip($scope.search.reportTypeTip);
                $scope.additionals.reportTypeTip = $scope.search.reportTypeTip;
            }
            $scope.search['reportType'] = 'reportTip';
            $scope.additionals['reportType'] = 'reportTip';
            $scope.title = 'Dispecerat / Raport tips';
            $scope.classAction = 'td-small';
        }

        if ($location.path() == $scope.path + '/reportActivity') {
          $scope.columns = {
              'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
              'total_time': {'label': 'Timp total', 'filter': 1, 'filterType': 'input'},
              'active_time': {'label': 'Timp activ', 'filter': 1, 'filterType': 'input'},
              'disconnected_time': {'label': 'Timp deconectat', 'filter': 1, 'filterType': 'input'},
              'inactive_time': {'label': 'Timp inactiv', 'filter': 1, 'filterType': 'input'},
          };
            $scope.search['reportType'] = 'reportActivity';
            $scope.additionals['reportType'] = 'reportActivity';
            $scope.title = 'Dispecerat / Raport activitate soferi';
            $scope.classAction = 'td-small';
        }

        if ($location.path() == $scope.path + '/reportGeneral') {
            $scope.search.reportTypeGeneral = 'driver';
            if (angular.isUndefined($scope.search.reportTypeGeneral)) {
                $scope.search.reportTypeGeneral = 'driver';
            }
            $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
            $scope.searchModel = function (ev, path) {
                $scope.searchControl = true;
                $scope.last = 0;
                $scope.firstTime = 1;
                $scope.firstLoad = 0;
                $scope.getPaginateModel(path, 1, $scope.defaultItem);
                $scope.changeColumns($scope.search.reportTypeGeneral);
                $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
            }
            $scope.search['reportType'] = 'reportGeneral';
            $scope.additionals['reportType'] = 'reportGeneral';
            $scope.title = 'Dispecerat / Raport general';
            $scope.classAction = 'td-small';
        }

        if ($location.path() == $scope.path + '/reportDetailDriver') {
            $scope.columns = {
                'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                'created_at': {'label': 'Data', 'filter': 1, 'filterType': 'input'},
                'slot_no': {'label': 'Nr. slot', 'filter': 1, 'filterType': 'input'},
                'orders': {'label': 'Comenzi', 'filter': 2, 'filterType': 'input'},

                //'total_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_cash': {'label': 'Cash de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_card': {'label': 'Card de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_online': {'label': 'Online (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bonsv': {'label': 'Bonuri de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bank_transfer': {'label': 'Transfer bancar (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                'total_driver': {'label': 'Total cash de colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                'total_cash_collected': {'label': 'Cash colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_card_collected': {'label': 'Card colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bonsv_collected': {'label': 'Bonuri colectate sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bank_transfer_collected': {'label': 'Transfer bancar colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                /*'amount_driver_cash_collected':{'label':'Cash colectat sofer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                 'amount_driver_card_collected':{'label':'Card colectat sofer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                 //'amount_driver_online_collected':{'label':'Online ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                 'amount_driver_bonv_collected':{'label':'Bonuri colectate sofer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},*/
                'driver_cash_over': {'label': 'Cash ramas de colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                // 'amount_dispatcher_cash_collected':{'label':'Suma incasata cash dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                //'driver_cash_over_to_dispatcher':{'label':'Total de predat sofer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                //'amount_driver_cash_required':{'label':'Total de predat sofer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total': {'label': 'Total slot (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
            };
            $scope.search['reportType'] = 'reportDetailDriver';
            $scope.additionals['reportType'] = 'reportDetailDriver';
            $scope.title = 'Soferi / Raport detaliat';
            $scope.classAction = 'td-small';
        }

        if ($location.path() == $scope.path + '/reportDailyDriver') {
            $scope.columns = {
                'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                'date': {'label': 'Data', 'filter': 1, 'filterType': 'input'},
                'slots_nos': {'label': 'Nr. sloturi', 'filter': 1, 'filterType': 'input'},
                'orders_nos': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},

                //'total_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_cash': {'label': 'Cash de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_card': {'label': 'Card de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_online': {'label': 'Online (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bonsv': {'label': 'Bonuri de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bank_transfer': {'label': 'Transfer bancar (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                'total_driver': {'label': 'Total cash sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                'total_cash_collected': {'label': 'Cash colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_card_collected': {'label': 'Card colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bonsv_collected': {'label': 'Bonuri colectate sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bank_transfer_collected': {'label': 'Transfer bancar colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                /*'total_amount_driver_cash_collected':{'label':'Cash colectat sofer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                 'total_amount_driver_card_collected':{'label':'Card colectat sofer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                 //'total_amount_driver_online_collected':{'label':'Online ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                 'total_amount_driver_bonv_collected':{'label':'Bonuri colectate sofer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                 'total_driver_cash_over':{'label':'Cash ramas de colectat sofer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},*/

                //'total_amount_dispatcher_cash_collected':{'label':'Suma incasata cash dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                //'total_amount_driver_cash_required':{'label':'Total de predat sofer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                //'total_amount_dispatcher_card_collected':{'label':'Suma incasata card dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total': {'label': 'Total sloturi (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
            };
            $scope.search['reportType'] = 'reportDailyDriver';
            $scope.additionals['reportType'] = 'reportDailyDriver';
            $scope.title = 'Soferi / Raport zilnic';
        }

        if ($location.path() == $scope.path + '/reportMonthlyDriver') {
            $scope.columns = {
                'month': {'label': 'Luna', 'filter': 1, 'filterType': 'input'},
                'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                'slots_nos': {'label': 'Nr. sloturi', 'filter': 1, 'filterType': 'input'},
                'orders_nos': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                'total_cash': {'label': 'Cash de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_card': {'label': 'Card de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_online': {'label': 'Online (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bonsv': {'label': 'Bonuri de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bank_transfer': {'label': 'Transfer bancar (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_driver': {'label': 'Total cash sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_cash_collected': {'label': 'Cash colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_card_collected': {'label': 'Card colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bonsv_collected': {'label': 'Bonuri colectate sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_bank_transfer_collected': {'label': 'Transfer bancar colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total sloturi (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
            };
            $scope.search['reportType'] = 'reportMonthlyDriver';
            $scope.additionals['reportType'] = 'reportMonthlyDriver';
            $scope.title = 'Soferi / Raport lunar';
            $scope.classAction = 'td-small';
        }

        $scope.changeColumnsDriver = function (reportTypeGeneral) {
            $scope.classAction = 'td-small';
            if (reportTypeGeneral == 'driver') {
                $scope.columns = {
                    'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                    'slots_nos': {'label': 'Nr. sloturi', 'filter': 1, 'filterType': 'input'},
                    'orders_nos': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                    /*'total_partial': {
                     'label': 'Plata partiala (' + $rootScope.currency + ')',
                     'filter': 1,
                     'filterType': 'input'
                     },*/
                    'total_cash': {'label': 'Cash de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_card': {'label': 'Card de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_online': {'label': 'Online (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_bonsv': {'label': 'Bonuri de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_bank_transfer': {'label': 'Transfer bancar (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                    'total_driver': {
                        'label': 'Total cash sofer (' + $rootScope.currency + ')',
                        'filter': 1,
                        'filterType': 'input'
                    },

                    'total_cash_collected': {'label': 'Cash colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_card_collected': {'label': 'Card colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_bonsv_collected': {'label': 'Bonuri colectate sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_bank_transfer_collected': {'label': 'Transfer bancar colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                    //'total_amount_driver_cash_required':{'label':'Total de incasat sofer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                    //'total_amount_dispatcher_cash_collected':{'label':'Suma incasata cash dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                    //'total_amount_dispatcher_card_collected':{'label':'Suma incasata card dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                    'total': {
                        'label': 'Total sloturi (' + $rootScope.currency + ')',
                        'filter': 1,
                        'filterType': 'input'
                    }
                };
            }
            if (reportTypeGeneral == 'day') {
                $scope.columns = {
                    'date': {'label': 'Data', 'filter': 1, 'filterType': 'input'},
                    'slots_nos': {'label': 'Nr. sloturi', 'filter': 1, 'filterType': 'input'},
                    'orders_nos': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                    /*'total_partial': {
                     'label': 'Plata partiala (' + $rootScope.currency + ')',
                     'filter': 1,
                     'filterType': 'input'
                     },*/
                    'total_cash': {'label': 'Cash de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_card': {'label': 'Card de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_online': {'label': 'Online (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_bonsv': {'label': 'Bonuri de incasat (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_bank_transfer': {'label': 'Transfer bancar (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                    'total_cash_collected': {'label': 'Cash colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_card_collected': {'label': 'Card colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_bonsv_collected': {'label': 'Bonuri colectate sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                    'total_bank_transfer_collected': {'label': 'Transfer bancar colectat sofer (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},

                    'total_driver': {
                        'label': 'Total cash sofer (' + $rootScope.currency + ')',
                        'filter': 1,
                        'filterType': 'input'
                    },
                    //'total_amount_driver_cash_required':{'label':'Total de incasat sofer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                    // 'total_amount_dispatcher_cash_collected':{'label':'Suma incasata cash dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                    //'total_amount_dispatcher_card_collected':{'label':'Suma incasata card dispecer ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                    'total': {
                        'label': 'Total sloturi (' + $rootScope.currency + ')',
                        'filter': 1,
                        'filter': 1,
                        'filter': 1,
                        'filterType': 'input'
                    }
                };
            }
        }

        if ($location.path() == $scope.path + '/reportGeneralDriver') {
            $scope.search.reportTypeGeneral = 'driver';
            if (angular.isUndefined($scope.search.reportTypeGeneral)) {
                $scope.search.reportTypeGeneral = 'driver';
            }
            $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
            $scope.searchModel = function (ev, path) {
                $scope.searchControl = true;
                $scope.last = 0;
                $scope.firstTime = 1;
                $scope.firstLoad = 0;
                $scope.getPaginateModel(path, 1, $scope.defaultItem);
                $scope.changeColumnsDriver($scope.search.reportTypeGeneral);
                $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
            }
            $scope.search['reportType'] = 'reportGeneralDriver';
            $scope.additionals['reportType'] = 'reportGeneralDriver';
            $scope.title = 'Soferi / Raport general';
            $scope.classAction = 'td-small';
        }

        if ($location.path() == $scope.path + '/reportDailyDriverTime') {
            $scope.columns = {
                'date': {'label': 'Data', 'filter': 1, 'filterType': 'input'},
                'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                'slots_nos': {'label': 'Nr. sloturi', 'filter': 1, 'filterType': 'input'},
                'orders_nos': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                'average_delivery_time': {'label': 'Timp mediu de livrare', 'filter': 1, 'filterType': 'input'}
            };
            $scope.search['reportType'] = 'reportDailyDriverTime';
            $scope.additionals['reportType'] = 'reportDailyDriverTime';
            $scope.title = 'Dispecerat / Raport zilnic timp de livrare sofer';
        }

        if ($location.path() == $scope.path + '/reportDriverTime') {
            $scope.columns = {
                'driver_name': {'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                'slots_nos': {'label': 'Nr. sloturi', 'filter': 1, 'filterType': 'input'},
                'orders_nos': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                'average_delivery_time': {'label': 'Timp mediu de livrare', 'filter': 1, 'filterType': 'input'},
                'order_nos_exceeded': {'label': 'Nr. comenzi cu timp estimat depasit', 'filter': 1, 'filterType': 'input'},
                'percent_nos_estimated_time_exceeded': {'label': 'Timp estimat depasit %', 'filter': 1, 'filterType': 'input'}
            };
            $scope.search['reportType'] = 'reportDriverTime';
            $scope.additionals['reportType'] = 'reportDriverTime';
            $scope.title = 'Dispecerat / Raport timp de livrare sofer';
        }

        /* show model report detail */
        $scope.showModelReportDetail = function (ev, path, model) {
            if ($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'show';
                angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, "slow");
                $scope.modelData = {};
                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
                var typeRequest = 'form-urlencoded';
                model['route'] = 'showReportDetail';
                Crud.post(typeRequest, model, $scope.path + '/showReportDetail')
                        .success(function (data) {
                            $scope.slot = data;
                        });
            }
            if ($scope.mode_action == 'dialog') {
                $scope.additionals['buttonDisabled'] = true;
                var typeRequest = 'form-urlencoded';
                model['route'] = 'showReportDetail';
                Crud.post(typeRequest, model, $scope.path + '/showReportDetail')
                        .success(function (data) {
                            $mdDialog.show({
                                controller: DialogController,
                                templateUrl: 'showDialog.tmpl.html',
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: true,
                                locals: {
                                    pathTemplate: $scope.pathTemplate,
                                    model: data,
                                    search: $scope.search,
                                    formatText: $scope.formatText,
                                    formatDate: $scope.formatDate,
                                    columns: $scope.columns,
                                    additionals: $scope.additionals
                                },
                            });
                            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'search', 'formatText', 'formatDate', 'columns', 'additionals'];
                            function DialogController($scope, $mdDialog, pathTemplate, model, search, formatText, formatDate, columns, additionals) {
                                $scope.pathTemplate = pathTemplate;
                                $scope.slot = model;
                                $scope.additionals = additionals;
                                $scope.formatText = formatText;
                                $scope.formatDate = formatDate;
                                $scope.columns = columns;
                                $scope.search = search;

                                $scope.cancel = function () {
                                    $mdDialog.cancel();
                                };
                                $scope.additionals['buttonDisabled'] = false;
                            }
                        }).error(function (data) {
                    $scope.errors = data.errors;
                    $scope.additionals['buttonDisabled'] = false;
                });
            }
        };

        /* show model report daily */
        $scope.showModelReportDaily = function (ev, path, model) {
            if ($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'show';
                angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, "slow");
                $scope.modelData = {};
                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
                var typeRequest = 'form-urlencoded';
                model['route'] = 'showReportDaily';
                Crud.post(typeRequest, model, $scope.path + '/showReportDaily')
                        .success(function (data) {
                            $scope.slots = data;
                        });
            }
            if ($scope.mode_action == 'dialog') {
                $scope.additionals['buttonDisabled'] = true;
                var typeRequest = 'form-urlencoded';
                model['route'] = 'showReportDaily';
                Crud.post(typeRequest, model, $scope.path + '/showReportDaily')
                        .success(function (data) {
                            $mdDialog.show({
                                controller: DialogController,
                                templateUrl: 'showDialog.tmpl.html',
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: true,
                                locals: {
                                    pathTemplate: $scope.pathTemplate,
                                    model: data,
                                    search: $scope.search,
                                    formatText: $scope.formatText,
                                    formatDate: $scope.formatDate,
                                    columns: $scope.columns,
                                    additionals: $scope.additionals
                                },
                            });
                            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'search', 'formatText', 'formatDate', 'columns', 'additionals'];
                            function DialogController($scope, $mdDialog, pathTemplate, model, search, formatText, formatDate, columns, additionals) {
                                $scope.pathTemplate = pathTemplate;
                                $scope.slots = model;
                                $scope.additionals = additionals;
                                $scope.formatText = formatText;
                                $scope.formatDate = formatDate;
                                $scope.columns = columns;
                                $scope.search = search;

                                $scope.cancel = function () {
                                    $mdDialog.cancel();
                                };
                                $scope.additionals['buttonDisabled'] = false;
                            }
                        }).error(function (data) {
                    $scope.errors = data.errors;
                    $scope.additionals['buttonDisabled'] = false;
                });
            }
        };

        /* change status */
        $scope.changeStatus = function (ev, path, model, columns) {
            $scope.additionals['buttonDisabled'] = true;
            model.status = model.status == false ? 1 : 0;

            Crud.changeStatus(model, path)
                    .success(function (data) {
                        if (!angular.isUndefined(data.invalid)) {
                            $scope.additionals['invalid'] = data.invalid;
                        }
                        $scope.additionals['buttonDisabled'] = false;
                    });
        };

        /* show model report general */
        $scope.showModelReportGeneral = function (ev, path, model, type) {

            if ($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'show';
                angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, "slow");
                $scope.modelData = {};
                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
                var typeRequest = 'form-urlencoded';
                var post = {};
                model['route'] = 'showReportGeneral';
                model['type'] = '';
                if (!angular.isUndefined(type)) {
                        model['type'] = type;
                }
                model['reportTypeGeneral'] = $scope.search.reportTypeGeneral;
                Crud.post(typeRequest, model, $scope.path + '/showReportGeneral')
                        .success(function (data) {
                            $scope.resultsReport = data;
                            $scope.resultsReport['type'] = '';
                                if (!angular.isUndefined(type)) {
                                        $scope.resultsReport['type'] = type;
                                }
                        });
            }
            if ($scope.mode_action == 'dialog') {
                $scope.additionals['buttonDisabled'] = true;
                var typeRequest = 'form-urlencoded';
                model['route'] = 'showReportGeneral';
                model['type'] = '';
                 if (!angular.isUndefined(type)) {
                        model['type'] = type;
                }
                model['reportTypeGeneral'] = $scope.search.reportTypeGeneral;
                Crud.post(typeRequest, model, $scope.path + '/showReportGeneral')
                        .success(function (data) {
                            $mdDialog.show({
                                controller: DialogController,
                                templateUrl: 'showDialog.tmpl.html',
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: true,
                                locals: {
                                    pathTemplate: $scope.pathTemplate,
                                    model: data,
                                    search: $scope.search,
                                    formatText: $scope.formatText,
                                    formatDate: $scope.formatDate,
                                    columns: $scope.columns,
                                    additionals: $scope.additionals
                                },
                            });
                            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'search', 'formatText', 'formatDate', 'columns', 'additionals'];
                            function DialogController($scope, $mdDialog, pathTemplate, model, search, formatText, formatDate, columns, additionals) {
                                $scope.pathTemplate = pathTemplate;
                                $scope.resultsReport = data;
                                $scope.additionals = additionals;
                                $scope.formatText = formatText;
                                $scope.formatDate = formatDate;
                                $scope.columns = columns;
                                $scope.search = search;

                                $scope.cancel = function () {
                                    $mdDialog.cancel();
                                };
                                $scope.additionals['buttonDisabled'] = false;
                            }
                        }).error(function (data) {
                    $scope.errors = data.errors;
                    $scope.additionals['buttonDisabled'] = false;
                });
            }
        };

        $scope.cancelSearchReport = function (ev, path, reportType) {
            $scope.search = {};

            if ($scope.searchControl == true) {
                if (!angular.isUndefined(reportType)) {
                    $scope.search['reportType'] = reportType;
                    $scope.additionals['reportType'] = reportType;
                    if (reportType == 'reportGeneral') {
                        $scope.search.reportTypeGeneral = 'driver';
                        $scope.changeColumns($scope.search.reportTypeGeneral);
                        $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
                    }
                    if (reportType == 'reportGeneralDriver') {
                        $scope.search.reportTypeGeneral = 'driver';
                        $scope.changeColumnsDriver($scope.search.reportTypeGeneral);
                        $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
                    }
                }
                $scope.getPaginateModel(path, 1, $scope.defaultItem);
            }
            angular.element(document.querySelector('.expand-collapse-content')).slideToggle('200', function () {
                angular.element(document.querySelector('#collapse i')).toggleClass('fa-minus fa-plus');
            });
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            var form = document.getElementById('search-form');
            form.reset();

            $timeout($scope.removeDate, 500);

        }

        /* map */
        $scope.center = [46.779608, 23.593165];
        $scope.center_address = 'Cluj-Napoca, Strada Daniil P. Barceanu 10';

        $scope.initMap = function () {
            var LocalOpenStreet = L.tileLayer(
                    'https://api.947.ro:8081/tiles/{z}/{x}/{y}.png',
                    {maxZoom: 22, type: 'osm_local'}
            );

            if (!$scope.map) {
                $scope.map = L.map("map-slot", {
                    center: $scope.center,
                    zoom: 13,
                    scrollWheelZoom: true,
                    zoomControl: true,
                    layers: [LocalOpenStreet],
                });
                $scope.map.doubleClickZoom.disable();
                $scope.map.zoomControl.setPosition('bottomright');
                $scope.map._onResize();
                $scope.map.invalidateSize();

                var brightnessMapControl = L.Control.extend({
                    options: {
                        position: 'bottomright'
                    },
                    onAdd: function (map) {
                        var container = L.DomUtil.create('button', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-control-brightnessmap');
                        container.title = "Luminozitate/contrast";
                        container.onclick = function (ev) {
                            $scope.brightnessMap(ev);
                        }
                        return container;
                    }
                });
                $scope.map.addControl(new brightnessMapControl());

                var fullMapControl = L.Control.extend({
                    options: {
                        position: 'bottomright'
                    },
                    onAdd: function (map) {
                        var container = L.DomUtil.create('button', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-control-fullmap minus');
                        container.title = "Extinde harta";
                        container.onclick = function (ev) {
                            $scope.fullsizeMap(ev);
                        }
                        return container;
                    }
                });
                $scope.map.addControl(new fullMapControl());

                var fullScreenControl = L.Control.extend({
                    options: {
                        position: 'bottomright'
                    },
                    onAdd: function (map) {
                        var container = L.DomUtil.create('button', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-control-fullscreen minus');
                        container.title = "Fullscreen";
                        container.onclick = function (ev) {
                            $scope.fullscreenMap(ev);
                        }
                        return container;
                    }
                });
                $scope.map.addControl(new fullScreenControl());

                var legend = L.control({position: 'bottomleft'});
                legend.onAdd = function (map) {
                    var div = L.DomUtil.create('div', 'info legend'),
                            colors = ['rgba(143, 143, 143, 1)', 'rgba(255, 58, 54, 1)', 'rgba(84, 152, 236, 1)'],
                            labels = ['Nr.adresa >= 3', 'Nr.adresa < 3', 'Nr.adresa nul'];
                    for (var i = 0; i < colors.length; i++) {
                        div.innerHTML +=
                                '<i style="background:' + colors[i] + '"></i> ' +
                                labels[i] + '<br>';
                    }
                    return div;
                };
                legend.addTo($scope.map);

                var OpenStreetMap = L.tileLayer(
                        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                        {maxZoom: 18, type: 'osm'}
                );
                var terrainMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type: 'terrain'
                });
                var hybridMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type: 'hybrid'
                });
                var roadMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type: 'roadmap'
                });
                var satMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type: 'satellite'
                });
                var trafficMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type: 'roadmap'
                });
                var transitMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type: 'roadmap'
                });
                L.control.layers({
                    'LocalOpenStreet': LocalOpenStreet,
                    'OpenStreetMap': OpenStreetMap,
                    'Google Terrain': terrainMutant,
                    'Google Hybrid': hybridMutant,
                    'Google Roadmap': roadMutant,
                    'Google Aerial': satMutant,
                    'Google Traffic': trafficMutant,
                    'Google Transit': transitMutant
                }, {}, {
                    collapsed: true
                }).addTo($scope.map);

                $scope.map.on('baselayerchange', function (e) {
                    $scope.map.eachLayer(function (layer) {
                        if (layer.options.type == 'terrain' || layer.options.type == 'hybrid' || layer.options.type == 'road' || layer.options.type == 'sat' || layer.options.type == 'traffic' || layer.options.type == 'transit') {
                            $scope.map.options.maxZoom = 20;
                        }
                        if (layer.options.type == 'osm_local' || layer.options.type == 'osm') {
                            $scope.map.options.maxZoom = 18;
                        }
                    });
                });
            }
        }

        $scope.brightnessMap = function (ev) {
            angular.element(document.querySelector('.leaflet-layer')).toggleClass('opacity-layer ');
            angular.element(document.querySelector('.leaflet-google-layer')).toggleClass('opacity-layer ');
        }

        $scope.fullsizeMap = function (ev) {
            $scope.fullSize();
            angular.element(document.querySelector('.leaflet-control-fullmap')).toggleClass('minus plus');
            if ($scope.map) {
                $scope.map.invalidateSize();
            }
        }

        $scope.fullscreenMap = function (ev) {
            $scope.goPreview('map-canvas');
            angular.element(document.querySelector('.leaflet-control-fullscreen')).toggleClass('minus plus');
            angular.element(document.querySelector('.angular-leaflet-map')).css('height', '100%');
        }

        $scope.setCenter = function () {
            var center_popup = '<h1>' + $scope.center_address + '</h1>';
            if ($scope.map) {
                L.marker(
                        $scope.center,
                        {
                            draggable: false,
                            icon: L.divIcon({
                                className: 'driver-div-icon',
                                html: '<div class="marker marker-center"></div>',
                                popupAnchor: [0, -40]
                            })
                        }).addTo($scope.map).bindPopup(center_popup, {maxWidth: 150, maxHeight: 70});
            }
        }

        $scope.controlOpenMap = 0;
        $scope.controlButtonOpenMap = 1;
        angular.element(document).ready(function () {
            $timeout(function () {
                $scope.controlButtonOpenMap = 0;
            }, 1000);
        });
        $scope.openMap = function () {
            if ($scope.controlOpenMap == 0) {
                $scope.controlOpenMap = 1;
                $scope.initMap();
                $scope.setCenter();
                $scope.getOrders();
            } else {
                $scope.controlOpenMap = 0;
            }
        }

        $scope.idsMarkers = [];
        $rootScope.addMarkerOnSlot = function (slotNo, itemOrder, itemId) {
            $scope.additionals['controlRemoveItem'] = 0;

            if (angular.isUndefined(slotNo) || slotNo == '' || slotNo == 0) {
                $rootScope.errorMarker = 'obligatoriu';
            } else {
                if (isNaN(slotNo)) {
                    $rootScope.errorMarker = 'este tip numeric';
                } else {
                    if (slotNo < $rootScope.lastSlot) {
                        $rootScope.errorMarker = 'este >= ' + $rootScope.lastSlot;
                    } else {
                        var order_no = itemOrder;
                        var order_id = itemId;

                        var keySlot = slotNo - $rootScope.lastSlot;

                        var range = $scope.additionals['generateRange'](0, keySlot);
                        angular.forEach(range, function (rangeItem) {
                            if (angular.isUndefined($scope.additionals['slots'][rangeItem])) {
                                $scope.additionals['slots'][rangeItem] = {};
                            }
                            if (angular.isUndefined($scope.additionals['slots'][rangeItem].order_ids)) {
                                $scope.additionals['slots'][rangeItem].order_ids = [];
                            }
                            if (angular.isUndefined($scope.additionals['slots'][rangeItem].orders)) {
                                $scope.additionals['slots'][rangeItem].orders = [];
                            }
                        });

                        if (angular.isUndefined($scope.idsMarkers[keySlot])) {
                            $scope.idsMarkers[keySlot] = [];
                        }
                        $scope.idsMarkers[keySlot].push(order_id);
                        angular.forEach($scope.idsMarkers, function (items, keys) {
                            if (!angular.isUndefined(items)) {
                                $scope.idsMarkers[keys] = items.filter(function (item, i, ar) {
                                    return ar.indexOf(item) === i;
                                });
                            }
                        });
                        if (angular.isUndefined($scope.additionals['slots'][keySlot])) {
                            $scope.additionals['slots'][keySlot] = {};
                        }
                        $scope.additionals['changeOrder'](keySlot, $scope.idsMarkers[keySlot]);

                        if (!angular.isUndefined($scope.markers[order_no])) {
                            $scope.map.removeLayer($scope.markers[order_no]);
                        }
                        // delete $scope.markers[order_no];
                    }
                }

            }
        }

        $scope.createMarker = function (item) {
            if (!angular.isUndefined(item)) {

                var color;
                if (!angular.isUndefined(item.address_no)) {
                    item.address_no = item.address_no.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
                    if (item.address_no != null && item.address_no.length < 3) {
                        color = 'red';
                        var html = '<div class="marker-' + color + '"> <div class="marker-text">' + item.address_no + '</div> </div>';
                    }
                    if (item.address_no != null && item.address_no.length >= 3) {
                        color = 'gray';
                        var address_no = '';
                        var address_nos = item.address_no.substr(0, 3);
                        if (address_nos) {
                            var address_no_arr = address_nos.split('-');
                            if (address_no_arr[0]) {
                                address_no = address_no_arr[0];
                            } else {
                                address_no = address_nos;
                            }
                        } else {
                            address_no = address_nos;
                        }
                        var html = '<div class="marker-' + color + '"> <div class="marker-text">' + address_no + ' </div></div>';
                    }
                    if (item.address_no != null && item.address_no.length == 0) {
                        color = 'blue';
                        var html = '<div class="marker-' + color + '"> <div class="marker-text">' + item.address_no + ' </div></div>';
                    }
                } else {
                    color = 'blue';
                    var html = '<div class="marker-' + color + '"></div>';
                }

                if (!angular.isUndefined(item.address_latitude) && !angular.isUndefined(item.address_longitude)) {
                    if (angular.isUndefined($scope.markers)) {
                        $scope.markers = [];
                    }
                    if (angular.isUndefined($scope.markerss)) {
                        $scope.markerss = [];
                    }

                    var address_section = '';
                    if (!angular.isUndefined(item.section_name) && item.section_name != null && item.section_name != '') {
                        var address_section = ", cart. " + item.section_name;
                    }

                    if ($scope.map) {
                        $scope.markers[item.order_no] = L.marker(
                                [Number(item.address_latitude), Number(item.address_longitude)],
                                {
                                    draggable: false,
                                    icon: L.divIcon({
                                        //className: 'driver-div-icon',
                                        html: html,
                                        popupAnchor: [0, -50]
                                    })
                                }).addTo($scope.map).bindPopup(null).on('click', function(e) {
                                    var _templateScope;
                                    if (!_templateScope) {
                                        _templateScope = $scope.$new();
                                    }
                                    _templateScope.itemMarker = item;
                                    var content = '<div ng-include src="\'views/' + $scope.pathTemplate + '/partials/_formMarker.html\'"></div>';
                                    var compiled = $compile(content)(_templateScope);

                                    $scope.markers[item.order_no].setPopupContent(compiled[0]);

                        });
                    }
                }
            }
        }

        $scope.modelReportCheckout = {};
        $scope.modelReportCheckout.dateFrom = current_init_date;
        $scope.reportCheckout = function (typeReport) {
            $scope.isLoadingReportCheckout = true;
            $scope.additionals['buttonDisabled'] = true;
            $scope.responseReportCheckout = '';

            var post = {};
            post['route'] = 'reportCheckout';
            post['typeReport'] = typeReport;
            if (typeReport == 'summary' || typeReport == 'detailed') {
              if (!angular.isUndefined($scope.modelReportCheckout.dateFrom)) {
                  post['dateFrom'] = moment($scope.modelReportCheckout.dateFrom).format('YYYY-MM-DD');
              }
              if (!angular.isUndefined($scope.modelReportCheckout.dateTo)) {
                  post['dateTo'] = moment($scope.modelReportCheckout.dateTo).format('YYYY-MM-DD');
              }
            }
            if (!angular.isUndefined($scope.modelReportCheckout.kitchen_id)) {
                 post['kitchen_id'] = $scope.modelReportCheckout.kitchen_id;
            }

            Crud.post('form-urlencoded', post, $scope.path + '/reportCheckout')
                .success(function (data) {
                    $scope.isLoadingReportCheckout = false;
                    $scope.responseReportCheckout = data.response;
                    $scope.typeReport = data.typeReport;
                    $scope.additionals['buttonDisabled'] = false;
                });
        }

        if (!angular.isUndefined($scope.orderStatus)) {
            $scope.additionals['order_status_string'] = JSON.stringify($scope.orderStatus.options);
        }
        if (!angular.isUndefined($scope.columnsOrdersActive.order_source)) {
            $scope.additionals['order_source_string'] = JSON.stringify($scope.columnsOrdersActive['order_source'].options);
        }
        if (!angular.isUndefined($scope.additionals['discount_campaign_type'])) {
            $scope.additionals['discount_campaign_type_string'] = JSON.stringify($scope.additionals['discount_campaign_type'].options);
        }
        if (!angular.isUndefined($scope.additionals['discount_campaign_value_type'])) {
            $scope.additionals['discount_campaign_value_type_string'] = JSON.stringify($scope.additionals['discount_campaign_value_type'].options);
        }
        if (!angular.isUndefined($scope.additionals['discount_types'])) {
            $scope.additionals['discount_types_string'] = JSON.stringify($scope.additionals['discount_types']);
        }
        if (!angular.isUndefined($scope.additionals['incident_department'])) {
            $scope.additionals['incident_department_string'] = JSON.stringify($scope.additionals['incident_department'].options);
        }
        if (!angular.isUndefined($scope.columns.slot_status)) {
            $scope.additionals['slot_status_string'] = JSON.stringify($scope.columns.slot_status.options);
        }
        if (!angular.isUndefined($scope.columns.status)) {
            $scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);
        }


    }]
);
